import axios from 'axios';
import moment from 'moment'
import { SV_SOJ_ORCMOCK_ADDRESS,SV_SOJ_SVDJMOCK_ADDRESS,SV_SOJ_SVDJMOCK_BRIDGE } from '../../constants';
import {typesFlyreview} from '../svtypes/flyreviewTypes'

const _ = require('lodash')
const headers = {'Content-Type': 'application/json'}

function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }
/*svn19 start */
export function flyLoadReviewNowMyReservationForCustId_org_svdec2(flyob, custProfile){
    let rqValuesSpaceId = flyob.id 
    console.log('%%%%%%%%%%%%%%%sv++++REST API  Nov19review For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
    return dispatch => {
        dispatch(svFlyLoadReviewBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/rrsvfinalpricerrr`
        const url_dj_hw = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/hhsvfinalpricehhr`
        let dob_body ={
            "travelers": []
        }
        let body = {
            "offer":{
                "type": "flight-offer",
                "id": "1",
                "source": "GDS",
                "instantTicketingRequired": false,
                "nonHomogeneous": false,
                "oneWay": false,
                "isUpsellOffer": false,
                "lastTicketingDate": "2024-10-25",
                "lastTicketingDateTime": "2024-10-25",
                "numberOfBookableSeats": 3,
                "itineraries": [
                    {
                        "duration": "PT6H24M",
                        "segments": [
                            {
                                "departure": {
                                    "iataCode": "EWR",
                                    "terminal": "B",
                                    "at": "2024-11-01T19:29:00"
                                },
                                "arrival": {
                                    "iataCode": "SFO",
                                    "terminal": "1",
                                    "at": "2024-11-01T22:53:00"
                                },
                                "carrierCode": "AS",
                                "number": "295",
                                "aircraft": {
                                    "code": "73H"
                                },
                                "operating": {
                                    "carrierCode": "AS"
                                },
                                "duration": "PT6H24M",
                                "id": "1",
                                "numberOfStops": 0,
                                "blacklistedInEU": false
                            }
                        ]
                    }
                ],
                "price": {
                    "currency": "USD",
                    "total": "788.07",
                    "base": "719.07",
                    "fees": [
                        {
                            "amount": "0.00",
                            "type": "SUPPLIER"
                        },
                        {
                            "amount": "0.00",
                            "type": "TICKETING"
                        }
                    ],
                    "grandTotal": "788.07"
                },
                "pricingOptions": {
                    "fareType": [
                        "PUBLISHED"
                    ],
                    "includedCheckedBagsOnly": true
                },
                "validatingAirlineCodes": [
                    "AS"
                ],
                "travelerPricings": [
                    {
                        "travelerId": "1",
                        "fareOption": "STANDARD",
                        "travelerType": "ADULT",
                        "price": {
                            "currency": "USD",
                            "total": "788.07",
                            "base": "719.07"
                        },
                        "fareDetailsBySegment": [
                            {
                                "segmentId": "1",
                                "cabin": "BUSINESS",
                                "fareBasis": "VH7OAVFN",
                                "brandedFare": "FR",
                                "brandedFareLabel": "FIRST",
                                "class": "D",
                                "includedCheckedBags": {
                                    "quantity": 2
                                },
                                "amenities": [
                                    {
                                        "description": "SEAT ASSIGNMENT",
                                        "isChargeable": false,
                                        "amenityType": "PRE_RESERVED_SEAT",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "MEAL 1",
                                        "isChargeable": false,
                                        "amenityType": "MEAL",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "PRIORITY BOARDING",
                                        "isChargeable": false,
                                        "amenityType": "TRAVEL_SERVICES",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "110V AC POWER",
                                        "isChargeable": false,
                                        "amenityType": "ENTERTAINMENT",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "USB POWER",
                                        "isChargeable": false,
                                        "amenityType": "ENTERTAINMENT",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "CHANGEABLE TICKET",
                                        "isChargeable": false,
                                        "amenityType": "BRANDED_FARES",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
        body.offer = flyob.svcookoffer_o
        /*
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/flyLoadReview`
        const body = {
            "query": {
              "match": {
                "FLIGHTSPACEKEY.keyword": (rqValuesSpaceId? rqValuesSpaceId:"1@4@1@ADQ") 
              }
            }
          }
        */

        const bodyBad = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                            }
                        }
                    ]
                }
            }
         }

        
          
        
        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojourPriceView`
        const bodyPriceGet = {
            "query": {
              "match": {
                "SPACEKEY.keyword": "10000416@4@F@10@10@20251124@7@Y@SVR"
              }
            }
          }
//localhost:8086/account/addressListByCustomerIdView
        const urlAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListByCustomerIdView`
        const bodyAddressList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
       
        const urlCardList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/cardListByCustomerIdView`
        const bodyCardList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
        if(custProfile && (custProfile.customerId > 0)){
            let customerId = custProfile.customerId
            bodyAddressList.docId.push("" + customerId)
            bodyCardList.docId.push("" + customerId)
        }else{
            console.log('Nov19review custProfile + error by UI')
        }
       

        axios.all([
            axios.post(url, body, {headers:headers}),
            axios.post(urlSpacePrice,bodyPriceGet, {headers:headers}),
            axios.post(urlAddressList, bodyAddressList, {headers:headers}),
            axios.post(urlCardList, bodyCardList, {headers:headers}),
        ], {
  timeout: 7000
})
        .then(
            axios.spread((r,r2, r3,r4)=>{


                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                       "airport_id": 30009,
                       "origin_airport_code": 1,
                       "origincity": "homer",
                       "origin_airport_city": "homer",
                       "origin_airport_country": "usa",
                       "origin_airport_timezone": "america/new_york",
                       "port_code_iata": 30009,
                       "airlines_db_id": 146,
                       "origin_airport_iata": "09a",
                       "dst_airport_code": "adq",
                       "airlines_vessel": "cr9",
                       "airlines_name_iata": "2o",
                       "airlines_code_iata": 4,
                       "flight_space_id": 13,
                       "flight_departure": "10:30",
                       "flight_departure_time": "10:30",
                       "flight_arrival": "04:30",
                       "flight_arrival_time": "04:30",
                       "flight_airline_num_stops": 1,
                       "flight_arrival_daytime": "pm",
                       "flight_departure_daytime": "am",
                       "startdate": "2023-11-24",
                       "enddate": "2026-12-01",
                       "airlines_name": "air salone",
                       "org_aiport_csc_addr": "homer,alaska,usa",
                       "flight_time_hhmm": "6hr 29min",
                       "flight_time": 209,
                       "flight_operated_by": "4009 operated by envoy airlines",
                       "flight_operator_owned": "y",
                       "origin_airport_state": "alaska",
                       "flight_departure_time_tzest": "2025-10-25t10:30:00-0400",
                       "flight_departure_date": "2025-10-25",
                       "flight_arrival_date": "2025-10-26",
                       "flight_arrival_time_tzest": "2025-10-26t16:30:00-0400",
                       "flight_space_key": "1@4@1@adq"
                   },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "dateOfBirth":"1982-01-16",
                    "gender":"MALE",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
               
                let price_tp = {
                    "currency": "USD",
                    "total": "788.07",
                    "base": "719.07",
                    "fees": [
                        {
                            "amount": "0.00",
                            "type": "SUPPLIER"
                        },
                        {
                            "amount": "0.00",
                            "type": "TICKETING"
                        },
                        {
                            "amount": "0.00",
                            "type": "FORM_OF_PAYMENT"
                        }
                    ],
                    "grandTotal": "788.07",
                    "billingCurrency": "USD"
                }
                let offer_tp = {
                    "type": "flight-offer",
                    "id": "1",
                    "source": "GDS",
                    "instantTicketingRequired": false,
                    "nonHomogeneous": false,
                    "paymentCardRequired": false,
                    "lastTicketingDate": "2024-10-25",
                    "itineraries": [
                        {
                            "segments": [
                                {
                                    "departure": {
                                        "iataCode": "EWR",
                                        "terminal": "B",
                                        "at": "2024-11-01T19:29:00"
                                    },
                                    "arrival": {
                                        "iataCode": "SFO",
                                        "terminal": "1",
                                        "at": "2024-11-01T22:53:00"
                                    },
                                    "carrierCode": "AS",
                                    "number": "295",
                                    "aircraft": {
                                        "code": "73H"
                                    },
                                    "operating": {
                                        "carrierCode": "AS"
                                    },
                                    "duration": "PT6H24M",
                                    "id": "1",
                                    "numberOfStops": 0,
                                    "co2Emissions": [
                                        {
                                            "weight": 612,
                                            "weightUnit": "KG",
                                            "cabin": "BUSINESS"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "price": {
                        "currency": "USD",
                        "total": "788.07",
                        "base": "719.07",
                        "fees": [
                            {
                                "amount": "0.00",
                                "type": "SUPPLIER"
                            },
                            {
                                "amount": "0.00",
                                "type": "TICKETING"
                            },
                            {
                                "amount": "0.00",
                                "type": "FORM_OF_PAYMENT"
                            }
                        ],
                        "grandTotal": "788.07",
                        "billingCurrency": "USD"
                    },
                    "pricingOptions": {
                        "fareType": [
                            "PUBLISHED"
                        ],
                        "includedCheckedBagsOnly": true
                    },
                    "validatingAirlineCodes": [
                        "AS"
                    ],
                    "travelerPricings": [
                        {
                            "travelerId": "1",
                            "fareOption": "STANDARD",
                            "travelerType": "ADULT",
                            "price": {
                                "currency": "USD",
                                "total": "788.07",
                                "base": "719.07",
                                "taxes": [
                                    {
                                        "amount": "5.00",
                                        "code": "ZP"
                                    },
                                    {
                                        "amount": "5.60",
                                        "code": "AY"
                                    },
                                    {
                                        "amount": "53.90",
                                        "code": "US"
                                    },
                                    {
                                        "amount": "4.50",
                                        "code": "XF"
                                    }
                                ],
                                "refundableTaxes": "5.60"
                            },
                            "fareDetailsBySegment": [
                                {
                                    "segmentId": "1",
                                    "cabin": "BUSINESS",
                                    "fareBasis": "VH7OAVFN",
                                    "brandedFare": "FR",
                                    "class": "D",
                                    "includedCheckedBags": {
                                        "quantity": 2
                                    }
                                }
                            ]
                        }
                    ]
                }
                let currencycode = '$'
                //rscode n19 start
                if(r.data){
                   

                   
                    if (r.data.flightOffers && r.data.flightOffers.length>0 && r.data.flightOffers[0].price ){
                        price_tp = r.data.flightOffers[0].price
                        offer_tp = r.data.flightOffers[0]
                        currencycode = price_tp.currency == "USD" ? "$": price_tp.currency

                    }else{
                        console.log('sv**weeorr Nov19review LOADREVIEW ERROR')
                    }
                    let priceOb= {

                        "total": price_tp.grandTotal,
                        "base": price_tp.base,
                        "depositValue":"0",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": price_tp.currency || "USD",
                        "taxes": [
                            {
                                "amount": "5.00",
                                "code": "ZP"
                            },
                            {
                                "amount": "5.60",
                                "code": "AY"
                            },
                            {
                                "amount": "53.90",
                                "code": "US"
                            },
                            {
                                "amount": "4.50",
                                "code": "XF"
                            }
                        ],
                        "tax": {
                           
                            "taxTotal": currencycode+"00",
                            "maintax":   currencycode+"00",
                            "citytax":   currencycode+"00",
                
                            "taxPercent": "0",
                            "citytaxPercent": "0"
                        },
                        "fees": [
                            {
                                "amount": "0.00",
                                "type": "SUPPLIER"
                            },
                            {
                                "amount": "0.00",
                                "type": "TICKETING"
                            },
                            {
                                "amount": "0.00",
                                "type": "FORM_OF_PAYMENT"
                            }
                        ]
                    }
                    priceOb.fees = price_tp.fees
                    priceOb.taxes = price_tp.taxes
                    if(priceOb){
                        my_data_review_tp.price = priceOb
                    }
                    if(offer_tp){
                        my_data_review_tp.offer = offer_tp
                    }
                    let comData = {my_data_flyreview:my_data_review_tp, my_data_flyaddress:null, my_data_card:null}
                     
                    //r3 address starts
                    let custProfileClone = {
                        customerId: -11
                    }
                    if( r3.data  && r3.data.length>0){

                        

                        let ob3,sod3
                        const ar3 = r3.data 
                        const a_rec3 = ar3[0] || {}
                        ob3 = a_rec3
                        let my_data_flyaddress = ob3
                    
                        comData.my_data_flyaddress = my_data_flyaddress

                        sod3 =  _.clone(ob3)

                        my_data_review_tp.email = sod3.email
                        my_data_review_tp.addressType =sod3.addressType	? sod3.addressType :'B'
                        my_data_review_tp.fname = sod3.fname
                        my_data_review_tp.lname = sod3.lname
                        my_data_review_tp.addressId = sod3.addressId
                        my_data_review_tp.phone = sod3.phone
                        my_data_review_tp.email = sod3.email
                        my_data_review_tp.login = sod3.login
                        my_data_review_tp.city = sod3.city
                        my_data_review_tp.country = sod3.country
                        my_data_review_tp.state = sod3.state
                        my_data_review_tp.address = (sod3.address ?  sod3.address :"No address in DB")
                        my_data_review_tp.zip = sod3.zipcode
                        my_data_review_tp.isdcode = sod3.isdcode
                        my_data_review_tp.dcountry = sod3.country

                        my_data_review_tp.dateOfBirth = (sod3.dateOfBirth ? sod3.dateOfBirth:"1982-01-16")
                        my_data_review_tp.gender = (sod3.gender ? sod3.gender:"MALE")
                        
                        /*
                        "dateOfBirth":"1982-01-16",
                        "gender":"MALE",
                        */
                        //dob  and gender for ods

                        if(sod3.customerId > 0){
                            custProfileClone.customerId = sod3.customerId
                            
                            
                        }
                        if(sod3.addressId > 0){
                            custProfileClone.addressId = sod3.addressId

                        }

                       


                    }


                    
                    comData.custProfile = custProfileClone
                    console.log('%%%sv*** svreviewaction  Nov19review comdata with custProfile froms db start')
                    console.log(custProfile)
                    //svr3 address end
                    //svr4 card start
                    if( r4.data  && r4.data.length>0){

                        

                        let ob4,sod4
                        const ar4 = r4.data 
                        const a_rec4 = ar4[0] || {}
                        ob4 = a_rec4
                        let my_data_card = ob4
                        if(my_data_card.cardId && my_data_card.cardId > 0){
                            my_data_card.id =  my_data_card.cardId
                        }else{
                            my_data_card.id = -12
                        }
                        if(my_data_card.cardNumber && my_data_card.cardNumber.length > 0){
                            my_data_card.card =  my_data_card.cardNumber
                        }else{
                            my_data_card.cardNumber = "7777777777777777"
                        }
                        if(my_data_card.cardCvv && my_data_card.cardCvv.length > 0){
                            my_data_card.cvv =  my_data_card.cardCvv
                        }else{
                            my_data_card.cvv = "777"
                        }
                    
                        if(my_data_card.cardExpMonth && my_data_card.cardExpMonth.length > 0){
                            my_data_card.mmexp =  my_data_card.cardExpMonth
                        }else{
                            my_data_card.mmexp = "07"
                        }
                    
                        if(my_data_card.cardExpYear && my_data_card.cardExpYear.length > 0){
                            my_data_card.yyyyexp =  my_data_card.cardExpYear
                        }else{
                            my_data_card.yyyyexp = "77"
                        }
                    
                    
                        comData.my_data_card = my_data_card
                    }
                    console.log('**SV Nov19review for exisitng customer Oct8*******')
                    console.log(comData)
                    console.log('%%%sv*** svreviewaction comdata with custProfile froms db end')
           

                    //svr4 card end
                    dispatch(getFlyLoadReviewNyReservationCustSuccess(comData))
                }else{
                    //abadon booking or review
                    const comData = {my_data_flyreview:my_data_review_tp}
                    comData.custProfile =null
                    dispatch(getFlyLoadReviewNyReservationCustSuccess(comData))
          

                }

                
                //rscode n19 end
            })
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
        //localhost:8086/account/cardListByCustomerIdView
      
        
    }
}
            
    
/*svn19 end*/

/*svnov8 START this ssvtep2 of ods it needs productId to be created first for ctsomerid say 3  apssed  *******/

export function flypriceAndTexNowSecure_svcurrent_nov27(rqValues, svtv){
    console.log(rqValues)
    console.log(svtv)
  console.log('%%%%%%%%%%%%%%%sv++++REST API For PY priceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
  return dispatch => {
      dispatch(svflypriceAndTexBegin())
      //let url82 = 'http://localhost:8082/amcos/createFullzz'
      //let url82 = 'http://localhost:8082/amcos/createFullMulti'
      //`${SV_SOJ_ORCMOCK_ADDRESS}/essearch/createTravellersMulti`
      let url82 = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/createTravellersMulti`
      
      let url82_cors_issue ='/amcos/createFullzz' 
      //use when booking succeeds as tis will save in db. call dj from java restclient is robust and takes headers
      let url82_svgood_working = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/saveAmcosReservationSecure`
      //const urlNewCustomer = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/bbsvbookonebr`
      const urlNewCustomer = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/mmsvbookmultimm`
      
      /*sva */
      const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/airPriceAndTaxReviewMultiEntityMYRESERVATIONSVSecure`
     /*
      const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
      rqValues = {"id":90}
      */
      /*svae*/
      let url  = urlNewCustomer
      if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
        console.log('%%%%%%%%%%%%%%%sv++++REST API  Non19 For priceAndTexNow LATEST**from Microservices DB with 8086 url :' + urlMyReservation)

        //url = urlMyReservation
        //like localhost:8082/amcos/createFull
        //amcos/createFullMulti
       // url82 = 'http://localhost:8082/amcos/createFullMulti'

    }
      let t = null,contact_user_phone = null
      if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
          console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow LATEST**from Microservices DB with 8086 url :' + urlMyReservation)
  
          //do nothingo ds reservation doesnot care wether new or old customer

      }
      let ui_rq = {
          "offer": {
              "type": "flight-offer",
              "id": "1",
              "source": "GDS",
              "instantTicketingRequired": false,
              "nonHomogeneous": false,
              "paymentCardRequired": false,
              "lastTicketingDate": "2024-10-25",
              "itineraries": [
                  {
                      "segments": [
                          {
                              "departure": {
                                  "iataCode": "EWR",
                                  "terminal": "B",
                                  "at": "2024-11-01T19:29:00"
                              },
                              "arrival": {
                                  "iataCode": "SFO",
                                  "terminal": "1",
                                  "at": "2024-11-01T22:53:00"
                              },
                              "carrierCode": "AS",
                              "number": "295",
                              "aircraft": {
                                  "code": "73H"
                              },
                              "operating": {
                                  "carrierCode": "AS"
                              },
                              "duration": "PT6H24M",
                              "id": "1",
                              "numberOfStops": 0,
                              "co2Emissions": [
                                  {
                                      "weight": 612,
                                      "weightUnit": "KG",
                                      "cabin": "BUSINESS"
                                  }
                              ]
                          }
                      ]
                  }
              ],
              "price": {
                  "currency": "USD",
                  "total": "788.07",
                  "base": "719.07",
                  "fees": [
                      {
                          "amount": "0.00",
                          "type": "SUPPLIER"
                      },
                      {
                          "amount": "0.00",
                          "type": "TICKETING"
                      },
                      {
                          "amount": "0.00",
                          "type": "FORM_OF_PAYMENT"
                      }
                  ],
                  "grandTotal": "788.07",
                  "billingCurrency": "USD"
              },
              "pricingOptions": {
                  "fareType": [
                      "PUBLISHED"
                  ],
                  "includedCheckedBagsOnly": true
              },
              "validatingAirlineCodes": [
                  "AS"
              ],
              "travelerPricings": [
                  {
                      "travelerId": "1",
                      "fareOption": "STANDARD",
                      "travelerType": "ADULT",
                      "price": {
                          "currency": "USD",
                          "total": "788.07",
                          "base": "719.07",
                          "taxes": [
                              {
                                  "amount": "5.00",
                                  "code": "ZP"
                              },
                              {
                                  "amount": "5.60",
                                  "code": "AY"
                              },
                              {
                                  "amount": "53.90",
                                  "code": "US"
                              },
                              {
                                  "amount": "4.50",
                                  "code": "XF"
                              }
                          ],
                          "refundableTaxes": "5.60"
                      },
                      "fareDetailsBySegment": [
                          {
                              "segmentId": "1",
                              "cabin": "BUSINESS",
                              "fareBasis": "VH7OAVFN",
                              "brandedFare": "FR",
                              "class": "D",
                              "includedCheckedBags": {
                                  "quantity": 2
                              }
                          }
                      ]
                  }
              ]
          },
          "product": null,
          "card": {
              "id": "-1",
              "card": "7777123412341234",
              "cvv": "345",
              "mmexp": "03",
              "yyyyexp": "23",
              "otherDetails": "SVMed facility",
              "privateparking": "N",
              "rentcar": "N",
              "bookTaxi": "N",
              "needFlight": "N",
              "cardId": "-4",
              "cardNumber": "7777777777777777",
              "gene": "77771234--1234--1234"
          },
          "traveller": {
              "id": "-1",
              "gene": "1",
              "fname": "alen",
              "lname": "sim",
              "email": "alen@sv.com",
              "address": "12 lin",
              "city": "san jose",
              "state": "CA",
              "zip": "95020",
              "country": "usa",
              "isdcode": "1",
              "phone": "4081231234",
              "bookingAgentType": "S",
              "traveType": "P",
              "specialRequests": "Wheel chair and Senior Citizen",
              "card": "1234-1234--1234--1234",
              "cvv": "Glen",
              "mmexp": "04",
              "yyyyexp": "2028",
              "addressId": 36,
              "customerId": 36,
              "name": "alen beta",
              "login": "alenb",
              "password": null,
              "otherDetails": "need pickup",
              "zipcode": "99999",
              "addressType": "B",
              "createdDate": null,
              "modifiedDate": null,
              "createdBy": null,
              "modifiedBy": null
          },
          "reservationAirProduct": {
              "productCategoryCode": 5,
              "productName": "AlaskaVacationKate57",
              "productDetails": "AlaskaVacationKate57",
              "description": "Alaska Kate57",
              "producttype": "svr",
              "flight_space_id": 13,
              "flight_space_key": "1@4@1@adq",
              "sale_ind": "Y",
              "vernacularcode": "en",
              "sojourncode": "RMC",
              "startdate": "2023-11-24",
              "enddate": "2026-12-01",
              "commoditytype": "RMc",
              "companycode": "SVR",
              "week": 11,
              "year": 24,
              "exchange_value": 12,
              "season": "RED",
              "bkgrnd_srch_sw": "Y",
              "pool": "NAMER",
              "maxoccupancy": "2",
              "flight_rack_rate": 23,
              "webStatusFlag": "Y",
              "srciata": "09a",
              "dstiata": "adq",
              "airlinesNameIata": "2o",
              "airlinesCodeIata": 4,
              "flightAirlineNumStops": 1,
              "flightDepartureTimeTzest": "2025-10-25t10:30:00-0400",
              "flightArrivalTimeTzest": "2025-10-26t16:30:00-0400",
              "flightOperatedBy": "4009 operated by envoy airlines",
              "flightOperatedOwned": "y",
              "flightTimeHhmm": "6hr 29min",
              "svCleanupColPending": "Y",
              "flightid": 57,
              "languagecode": "en",
              "svrtypeid": "SVR"
          },
          "meta": {
              "addressId": 36,
              "customerId": 36,
              "cardId": -1
          }
      }
      let dob_body ={
        "travelers": []
    }
      let body = {
          "sv_offer": {
              "type": "flight-offer",
              "id": "1",
              "source": "GDS",
              "instantTicketingRequired": false,
              "nonHomogeneous": false,
              "oneWay": false,
              "isUpsellOffer": false,
              "lastTicketingDate": "2024-10-25",
              "lastTicketingDateTime": "2024-10-25",
              "numberOfBookableSeats": 7,
              "itineraries": [
                  {
                      "duration": "PT6H11M",
                      "segments": [
                          {
                              "departure": {
                                  "iataCode": "EWR",
                                  "terminal": "B",
                                  "at": "2024-11-01T19:59:00"
                              },
                              "arrival": {
                                  "iataCode": "LAX",
                                  "terminal": "6",
                                  "at": "2024-11-01T23:10:00"
                              },
                              "carrierCode": "AS",
                              "number": "287",
                              "aircraft": {
                                  "code": "7M9"
                              },
                              "operating": {
                                  "carrierCode": "AS"
                              },
                              "duration": "PT6H11M",
                              "id": "2",
                              "numberOfStops": 0,
                              "blacklistedInEU": false
                          }
                      ]
                  }
              ],
              "price": {
                  "currency": "USD",
                  "total": "728.06",
                  "base": "663.26",
                  "fees": [
                      {
                          "amount": "0.00",
                          "type": "SUPPLIER"
                      },
                      {
                          "amount": "0.00",
                          "type": "TICKETING"
                      }
                  ],
                  "grandTotal": "728.06"
              },
              "pricingOptions": {
                  "fareType": [
                      "PUBLISHED"
                  ],
                  "includedCheckedBagsOnly": true
              },
              "validatingAirlineCodes": [
                  "AS"
              ],
              "travelerPricings": [
                  {
                      "travelerId": "1",
                      "fareOption": "STANDARD",
                      "travelerType": "ADULT",
                      "price": {
                          "currency": "USD",
                          "total": "728.06",
                          "base": "663.26"
                      },
                      "fareDetailsBySegment": [
                          {
                              "segmentId": "2",
                              "cabin": "BUSINESS",
                              "fareBasis": "VH7TAUFN",
                              "brandedFare": "FR",
                              "brandedFareLabel": "FIRST",
                              "class": "D",
                              "includedCheckedBags": {
                                  "quantity": 2
                              },
                              "amenities": [
                                  {
                                      "description": "SEAT ASSIGNMENT",
                                      "isChargeable": false,
                                      "amenityType": "PRE_RESERVED_SEAT",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "MEAL 1",
                                      "isChargeable": false,
                                      "amenityType": "MEAL",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "PRIORITY BOARDING",
                                      "isChargeable": false,
                                      "amenityType": "TRAVEL_SERVICES",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "110V AC POWER",
                                      "isChargeable": false,
                                      "amenityType": "ENTERTAINMENT",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "USB POWER",
                                      "isChargeable": false,
                                      "amenityType": "ENTERTAINMENT",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "CHANGEABLE TICKET",
                                      "isChargeable": false,
                                      "amenityType": "BRANDED_FARES",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  }
                              ]
                          }
                      ]
                  }
              ]
          },
          "sv_traveler_ar": [],
          "sv_traveler": {
              "id": "1",
              "dateOfBirth": "1982-01-16",
              "name": {
                  "firstName": "JORGE",
                  "lastName": "GONZALES"
              },
              "gender": "MALE",
              "contact": {
                  "emailAddress": "jorge.gonzales833@telefonica.es",
                  "phones": [
                      {
                          "deviceType": "MOBILE",
                          "countryCallingCode": "34",
                          "number": "480080076"
                      }
                  ]
              },
              "documents": [
                  {
                      "documentType": "PASSPORT",
                      "birthPlace": "Madrid",
                      "issuanceLocation": "Madrid",
                      "issuanceDate": "2015-04-14",
                      "number": "00000000",
                      "expiryDate": "2025-04-14",
                      "issuanceCountry": "ES",
                      "validityCountry": "ES",
                      "nationality": "ES",
                      "holder": true
                  }
              ]
          },
          "sv_remark": {
              "general": [
                  {
                      "subType": "GENERAL_MISCELLANEOUS",
                      "text": "ONLINE BOOKING FROM INCREIBLE VIAJES"
                  }
              ]
          },
          "sv_ticketingAgreement": {
              "option": "DELAY_TO_CANCEL",
              "delay": "6D"
          },
          "sv_contact": {
              "addresseeName": {
                  "firstName": "PABLO",
                  "lastName": "RODRIGUEZ"
              },
              "companyName": "INCREIBLE VIAJES",
              "purpose": "STANDARD",
              "phones": [
                  {
                      "deviceType": "LANDLINE",
                      "countryCallingCode": "34",
                      "number": "480080071"
                  },
                  {
                      "deviceType": "MOBILE",
                      "countryCallingCode": "33",
                      "number": "480080072"
                  }
              ],
              "emailAddress": "support@increibleviajes.es",
              "address": {
                  "lines": [
                      "Calle Prado, 16"
                  ],
                  "postalCode": "28014",
                  "cityName": "Madrid",
                  "countryCode": "ES"
              }
          }
      }
      //loder is boolean change in ingest add checkbok
      let py_tp_ar = []
      let py_tp = null

      let db_tp_ar = []
      let db_tp = null

      let tmp_phone_ob = null;
      //neeeded for gds vooking thisis profile
     
      let py_tp_traveler = {
        "id": "1",
        "dateOfBirth": "1982-01-16",
        "name": {
            "firstName": "JORGE",
            "lastName": "GONZALES"
        },
        "gender": "MALE",
        "contact": {
            "emailAddress": "jorge.gonzales833@telefonica.es",
            "phones": [
                {
                    "deviceType": "MOBILE",
                    "countryCallingCode": "34",
                    "number": "480080076"
                }
            ]
        },
        "documents": [
            {
                "documentType": "PASSPORT",
                "birthPlace": "Madrid",
                "issuanceLocation": "Madrid",
                "issuanceDate": "2015-04-14",
                "number": "00000000",
                "expiryDate": "2025-04-14",
                "issuanceCountry": "ES",
                "validityCountry": "ES",
                "nationality": "ES",
                "holder": true
            }
        ]
    }
    if(rqValues.my_data_svtoc){
       // let ta = rqValues.my_data_svtoc.members
        //let td = rqValues.my_data_svtoc.memphones
        let ta = []
        let td = null
        
        body['my_data_svtoc'] = rqValues.my_data_svtoc
        
        if (_.isArray(rqValues.my_data_svtoc)){
            ta = rqValues.my_data_svtoc
            t = ta[0]
            t.id = t.tid
            delete t.gene
            delete t.clubName
            delete t.tid
           
        }
         
        
        for(let i=0; i < ta.length; i++){
            t = ta[i]

           
            py_tp = _.clone(py_tp_traveler)
            py_tp["contact"] = {
                "emailAddress": "",
                "phones": [
                   
                ]
            }
            py_tp["name"] = {
                "firstName": "",
                "lastName": ""
            }
            if( t && t.memphones && _.isArray(t.memphones)){
                td = t.memphones
                py_tp["contact"][ "phones"] = t.memphones
                if(i ===0){
                    tmp_phone_ob =  t.memphones[0]
                    if(!tmp_phone_ob["deviceType"]){
                        tmp_phone_ob["deviceType"] ="MOBILE"
                    }
                   
                }
            }
            py_tp[ "id"] = t["tid"]
            py_tp[ "dateOfBirth"] = t["dateOfBirth"]
            py_tp[ "gender"] = t["gender"]
            
            
            py_tp["name"][ "firstName"] = t["firstName"]
            py_tp["name"][ "lastName"] = t["lastName"]
            
            py_tp["contact"][ "emailAddress"] = t["emailAddress"]

            
            let mp =  (td && td[0])? td[0] : null
            if(mp){
                contact_user_phone = {}
                //populate contact_user_phone
                //"deviceType": "MOBILE",
                contact_user_phone["deviceType"] ="MOBILE"
                contact_user_phone["countryCallingCode"] =mp["countryCallingCode"]
                contact_user_phone["number"] =mp["number"]
            }
            
            let mda = t["members"]
        
            if(mda && (mda.length > 0)){
            
                py_tp["documents"] = mda
                let doc = null;
                for(let k=0; k < mda.length; k++){
                    doc = mda[k]
                    if(doc["holder"] == "Y"){
                        doc["holder"] = true

                    }else{
                        doc["holder"] = true
                    }
                }
            }
            py_tp_ar.push(py_tp)
       

        }
        /*svn22 start*/
        for(let i=0; i < ta.length; i++){
            t = ta[i]

           
            db_tp = _.clone(py_tp_traveler)
            db_tp["contact"] = {
                "emailAddress": "",
                "phones": [
                   
                ]
            }
            db_tp["name"] = {
                "firstName": "",
                "lastName": ""
            }
            if( t && t.memphones && _.isArray(t.memphones)){
                td = t.memphones
                db_tp["contact"][ "phones"] = t.memphones
                if(i ===0){
                    tmp_phone_ob =  t.memphones[0]
                    if(!tmp_phone_ob["deviceType"]){
                        tmp_phone_ob["deviceType"] ="MOBILE"
                    }
                   
                }
            }
            db_tp[ "id"] = t["tid"]
            db_tp[ "dateOfBirth"] = t["dateOfBirth"]
            db_tp[ "gender"] = t["gender"]
            
            
            db_tp["name"][ "firstName"] = t["firstName"]
            db_tp["name"][ "lastName"] = t["lastName"]
            
            db_tp["contact"][ "emailAddress"] = t["emailAddress"]

            
            let mp =  (td && td[0])? td[0] : null
            if(mp){
                contact_user_phone = {}
                //populate contact_user_phone
                //"deviceType": "MOBILE",
                contact_user_phone["deviceType"] ="MOBILE"
                contact_user_phone["countryCallingCode"] =mp["countryCallingCode"]
                contact_user_phone["number"] =mp["number"]
            }
            
            let mda = t["members"]
            let db_documents = []
            let db_doc = null;
            if(mda && (mda.length > 0)){
            
                //db_tp["documents"] =  _.clone(mda) 
                let doc = null;
                for(let k=0; k < mda.length; k++){
                    doc = mda[k]
                    db_doc = _.clone(doc)
                    if(db_doc["holder"] === true){
                        db_doc["holder"] = "Y"

                    }else{
                        db_doc["holder"] = "N"
                    }
                    db_documents.push(db_doc)

                    
                }
            }
            db_tp["documents"] = db_documents
            db_tp_ar.push(db_tp)
       

        }
       
        dob_body["travelers"] = db_tp_ar
        /*svn22 end */
        body["sv_traveler_ar"] = py_tp_ar
        body["sv_traveler"] = py_tp_ar[0]
       
       
    }else{
     console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
    }
   
      let ambt_tp = {
  
          "dateOfBirth": "1982-01-15",
          "gender": "MALE",
          "documents": [
              {
                  
                  "documentType": "IDENTITY_CARD",
                  "birthPlace": "Madrid",
                  "issuanceLocation": "Madrid",
                  "issuanceDate": "2015-04-13",
                  "documentNumber": "00000069",
                  "expiryDate": "2025-04-13",
                  "issuanceCountry": "ES",
                  "validityCountry": "ES",
                  "nationality": "ES",
                  "holder": "Y"
                 
                  
              }
          ],
          "contact": {
              "emailAddress": "svr@yahoo.com",
              
              "phones": [
                  {
                      
                      "deviceType": "MOBILE",
                      "countryCallingCode": "34",
                     
                      
                      "number": "480080085"
                  }
              ]
          },
          "name": {
              "firstName": "Svbsv",
              "lastName": "Infinity"
          }
      }
      if(rqValues.offer){
          body.sv_offer = rqValues.offer
      }else{
       console.log('SVOCT28***ERROR********* SVWizard not sending offer***********')
      }
      let sv_contact_tp= {
        "addresseeName": {
            "firstName": "PABLO",
            "lastName": "RODRIGUEZ"
        },
        "companyName": "INCREIBLE VIAJES",
        "purpose": "STANDARD",
        "phones": [
            {
                "deviceType": "LANDLINE",
                "countryCallingCode": "34",
                "number": "480080071"
            },
            {
                "deviceType": "MOBILE",
                "countryCallingCode": "33",
                "number": "480080072"
            }
        ],
        "emailAddress": "support@increibleviajes.es",
        "address": {
            "lines": [
                "Calle Prado, 16"
            ],
            "postalCode": "28014",
            "cityName": "Madrid",
            "countryCode": "ES"
        }
    }
      if(rqValues.traveller){
          t = rqValues.traveller
          ambt_tp["contact"][ "emailAddress"] = t["email"]
          contact_user_phone =ambt_tp["contact"][ "phones"][0] 
          contact_user_phone["countryCallingCode"] =t["isdcode"]
          contact_user_phone["number"] =t["phone"]

          ambt_tp[ "dateOfBirth"] = t["dateOfBirth"]
          ambt_tp[ "gender"] = t["gender"]
          ambt_tp["name"][ "firstName"] = t["fname"]
          ambt_tp["name"][ "lastName"] = t["lname"]
        
          sv_contact_tp["addresseeName"]["firstName"] = t["fname"]
          sv_contact_tp["addresseeName"]["lastName"] = t["lname"]
          sv_contact_tp["purpose"]= "STANDARD"
          sv_contact_tp["phones"]= new Array()
          let profile_isd_2ltr = (t["isdcode"] &&  (t["isdcode"].length > 0 ) )? t["isdcode"] : "1" 
          
         
          let svp_tp = {
            "deviceType": "MOBILE",
            "countryCallingCode": profile_isd_2ltr,
            "number": t["phone"]
        }
        //teperay fix 
         svp_tp = tmp_phone_ob
         sv_contact_tp["phones"].push(svp_tp)
         sv_contact_tp["emailAddress"]= t["email"]

         sv_contact_tp["address"]["postalCode"] = t["zip"]
         sv_contact_tp["address"]["cityName"] = t["city"]
         sv_contact_tp["address"]["countryCode"] = "US"
         let country = t["country"]
         /*
         if(country && country.length > 2){
             //get country code from util fn before we come to actions
             let country_code = "US"
                  sv_contact_tp["address"]["countryCode"] = t["country"]
         }
         */

    
         sv_contact_tp["address"]["lines"] = new Array()
         let sva_addressline1 = t["address"]
         sv_contact_tp["address"]["lines"].push(sva_addressline1)
         body["sv_contact"] = sv_contact_tp
         console.log("Nov11 sv_contact_tp")
         console.log(sv_contact_tp)
        
         
      }else{
       console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
       console.log("Nov11 ***ERROR*****NO sv_contact_tp")
    }
     
     
        const authtoken = `Bearer ${svtv}`
        const svheaders = { 'Authorization': authtoken,
        'Content-Type': 'application/json' };
       
       let body_amcos_tp = {
    
            "dateOfBirth": "1982-01-15",
            "gender": "MALE",
            "documents": [
                {
                    
                    "documentType": "IDENTITY_CARD",
                    "birthPlace": "Madrid",
                    "issuanceLocation": "Madrid",
                    "issuanceDate": "2015-04-13",
                    "documentNumber": "00000069",
                    "expiryDate": "2025-04-13",
                    "issuanceCountry": "ES",
                    "validityCountry": "ES",
                    "nationality": "ES",
                    "holder": "Y"
                   
                    
                }
            ],
            "contact": {
                "emailAddress": "svr@yahoo.com",
                
                "phones": [
                    {
                        
                        "deviceType": "MOBILE",
                        "countryCallingCode": "34",
                       
                        
                        "number": "480080085"
                    }
                ]
            },
            "name": {
                "firstName": "Svbsv",
                "lastName": "Infinity"
            }
        }
        let body_amcos = body_amcos_tp
        if(rqValues.traveller){
            t = rqValues.traveller
            body_amcos["contact"][ "emailAddress"] = t["email"]
            contact_user_phone =body_amcos["contact"][ "phones"][0] 
            if(t["isdcode"] && t["isdcode"].length > 2){
                contact_user_phone["countryCallingCode"] =t["isdcode"]
            }else{
                contact_user_phone["countryCallingCode"] ="1"
            }
            
            contact_user_phone["number"] =t["phone"]
  
            body_amcos[ "dateOfBirth"] = t["dateOfBirth"]
            body_amcos[ "gender"] = t["gender"]
            body_amcos["name"][ "firstName"] = t["fname"]
            body_amcos["name"][ "lastName"] = t["lname"]
  
           
        }else{
         console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
        }
       
        
        axios.all([

            axios.post(url, body, {headers:headers}),
            axios.post(url82, dob_body,{headers:headers})
           // axios.post(url82, body_amcos,{headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{

                let comData = {
                    "my_data_fly_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                /*sva */
                let crudsuccessob ={
                    "timestamp": "2015-08-23T02:27:18.038+0000",
                    "status": 200,
                    "error": "",
                    "message": "Create Done ",
                    "path": "/kk/svaddressDetailPost"
                }
                comData.crudsuccessob = crudsuccessob
                if(r2.data){
                    console.log('Nov2 **82 save reservation')
                    console.log(r2.data)
                }
                /*svae */
                if(r.data){
                   
                    const ob_ar = r.data
                    const ob = ob_ar[0]
                    const {associatedRecords} = ob
                    if(!ob.reference ){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getPriceAndTexError(eeb))
                    }else{
                        comData.my_data_fly_price_confirmation.confirmationNumber =associatedRecords[0].reference

                        comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_fly_price_confirmation.confirmationNumber
                    

                   
                        dispatch(getPriceAndTexSuccess(comData))
             
                    }
                   
                          }
                else {
                    comData.my_data_fly_price_confirmation.status = "FAILED"
                    comData.my_data_fly_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_fly_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexError(comData))
                }
            })
        ).catch(
            e=>dispatch(getPriceAndTexError(e))
               
        )
     
      
  }

}

/*svnov8        END************/
  export function flypriceAndTexNowSecure_single_traveller(rqValues, svtv){
    console.log(rqValues)
    console.log(svtv)
  console.log('%%%%%%%%%%%%%%%sv++++REST API For PY priceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
  return dispatch => {
      dispatch(svflypriceAndTexBegin())
      let url82 = 'http://localhost:8082/amcos/createFullzz'
      let url82_cors_issue ='/amcos/createFullzz' 
      //use when booking succeeds as tis will save in db. call dj from java restclient is robust and takes headers
      let url82_svgood_working = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/saveAmcosReservationSecure`
      const urlNewCustomer = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/bbsvbookonebr`
      /*sva */
      const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/airPriceAndTaxReviewMultiEntityMYRESERVATIONSVSecure`
     /*
      const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
      rqValues = {"id":90}
      */
      /*svae*/
      let url  = urlNewCustomer
      let t = null,contact_user_phone = null
      if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
          console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow LATEST**from Microservices DB with 8086 url :' + urlMyReservation)
  
          url = urlMyReservation

      }
      let ui_rq = {
          "offer": {
              "type": "flight-offer",
              "id": "1",
              "source": "GDS",
              "instantTicketingRequired": false,
              "nonHomogeneous": false,
              "paymentCardRequired": false,
              "lastTicketingDate": "2024-10-25",
              "itineraries": [
                  {
                      "segments": [
                          {
                              "departure": {
                                  "iataCode": "EWR",
                                  "terminal": "B",
                                  "at": "2024-11-01T19:29:00"
                              },
                              "arrival": {
                                  "iataCode": "SFO",
                                  "terminal": "1",
                                  "at": "2024-11-01T22:53:00"
                              },
                              "carrierCode": "AS",
                              "number": "295",
                              "aircraft": {
                                  "code": "73H"
                              },
                              "operating": {
                                  "carrierCode": "AS"
                              },
                              "duration": "PT6H24M",
                              "id": "1",
                              "numberOfStops": 0,
                              "co2Emissions": [
                                  {
                                      "weight": 612,
                                      "weightUnit": "KG",
                                      "cabin": "BUSINESS"
                                  }
                              ]
                          }
                      ]
                  }
              ],
              "price": {
                  "currency": "USD",
                  "total": "788.07",
                  "base": "719.07",
                  "fees": [
                      {
                          "amount": "0.00",
                          "type": "SUPPLIER"
                      },
                      {
                          "amount": "0.00",
                          "type": "TICKETING"
                      },
                      {
                          "amount": "0.00",
                          "type": "FORM_OF_PAYMENT"
                      }
                  ],
                  "grandTotal": "788.07",
                  "billingCurrency": "USD"
              },
              "pricingOptions": {
                  "fareType": [
                      "PUBLISHED"
                  ],
                  "includedCheckedBagsOnly": true
              },
              "validatingAirlineCodes": [
                  "AS"
              ],
              "travelerPricings": [
                  {
                      "travelerId": "1",
                      "fareOption": "STANDARD",
                      "travelerType": "ADULT",
                      "price": {
                          "currency": "USD",
                          "total": "788.07",
                          "base": "719.07",
                          "taxes": [
                              {
                                  "amount": "5.00",
                                  "code": "ZP"
                              },
                              {
                                  "amount": "5.60",
                                  "code": "AY"
                              },
                              {
                                  "amount": "53.90",
                                  "code": "US"
                              },
                              {
                                  "amount": "4.50",
                                  "code": "XF"
                              }
                          ],
                          "refundableTaxes": "5.60"
                      },
                      "fareDetailsBySegment": [
                          {
                              "segmentId": "1",
                              "cabin": "BUSINESS",
                              "fareBasis": "VH7OAVFN",
                              "brandedFare": "FR",
                              "class": "D",
                              "includedCheckedBags": {
                                  "quantity": 2
                              }
                          }
                      ]
                  }
              ]
          },
          "product": null,
          "card": {
              "id": "-1",
              "card": "7777123412341234",
              "cvv": "345",
              "mmexp": "03",
              "yyyyexp": "23",
              "otherDetails": "SVMed facility",
              "privateparking": "N",
              "rentcar": "N",
              "bookTaxi": "N",
              "needFlight": "N",
              "cardId": "-4",
              "cardNumber": "7777777777777777",
              "gene": "77771234--1234--1234"
          },
          "traveller": {
              "id": "-1",
              "gene": "1",
              "fname": "alen",
              "lname": "sim",
              "email": "alen@sv.com",
              "address": "12 lin",
              "city": "san jose",
              "state": "CA",
              "zip": "95020",
              "country": "usa",
              "isdcode": "1",
              "phone": "4081231234",
              "bookingAgentType": "S",
              "traveType": "P",
              "specialRequests": "Wheel chair and Senior Citizen",
              "card": "1234-1234--1234--1234",
              "cvv": "Glen",
              "mmexp": "04",
              "yyyyexp": "2028",
              "addressId": 36,
              "customerId": 36,
              "name": "alen beta",
              "login": "alenb",
              "password": null,
              "otherDetails": "need pickup",
              "zipcode": "99999",
              "addressType": "B",
              "createdDate": null,
              "modifiedDate": null,
              "createdBy": null,
              "modifiedBy": null
          },
          "reservationAirProduct": {
              "productCategoryCode": 5,
              "productName": "AlaskaVacationKate57",
              "productDetails": "AlaskaVacationKate57",
              "description": "Alaska Kate57",
              "producttype": "svr",
              "flight_space_id": 13,
              "flight_space_key": "1@4@1@adq",
              "sale_ind": "Y",
              "vernacularcode": "en",
              "sojourncode": "RMC",
              "startdate": "2023-11-24",
              "enddate": "2026-12-01",
              "commoditytype": "RMc",
              "companycode": "SVR",
              "week": 11,
              "year": 24,
              "exchange_value": 12,
              "season": "RED",
              "bkgrnd_srch_sw": "Y",
              "pool": "NAMER",
              "maxoccupancy": "2",
              "flight_rack_rate": 23,
              "webStatusFlag": "Y",
              "srciata": "09a",
              "dstiata": "adq",
              "airlinesNameIata": "2o",
              "airlinesCodeIata": 4,
              "flightAirlineNumStops": 1,
              "flightDepartureTimeTzest": "2025-10-25t10:30:00-0400",
              "flightArrivalTimeTzest": "2025-10-26t16:30:00-0400",
              "flightOperatedBy": "4009 operated by envoy airlines",
              "flightOperatedOwned": "y",
              "flightTimeHhmm": "6hr 29min",
              "svCleanupColPending": "Y",
              "flightid": 57,
              "languagecode": "en",
              "svrtypeid": "SVR"
          },
          "meta": {
              "addressId": 36,
              "customerId": 36,
              "cardId": -1
          }
      }
      let body = {
          "sv_offer": {
              "type": "flight-offer",
              "id": "1",
              "source": "GDS",
              "instantTicketingRequired": false,
              "nonHomogeneous": false,
              "oneWay": false,
              "isUpsellOffer": false,
              "lastTicketingDate": "2024-10-25",
              "lastTicketingDateTime": "2024-10-25",
              "numberOfBookableSeats": 7,
              "itineraries": [
                  {
                      "duration": "PT6H11M",
                      "segments": [
                          {
                              "departure": {
                                  "iataCode": "EWR",
                                  "terminal": "B",
                                  "at": "2024-11-01T19:59:00"
                              },
                              "arrival": {
                                  "iataCode": "LAX",
                                  "terminal": "6",
                                  "at": "2024-11-01T23:10:00"
                              },
                              "carrierCode": "AS",
                              "number": "287",
                              "aircraft": {
                                  "code": "7M9"
                              },
                              "operating": {
                                  "carrierCode": "AS"
                              },
                              "duration": "PT6H11M",
                              "id": "2",
                              "numberOfStops": 0,
                              "blacklistedInEU": false
                          }
                      ]
                  }
              ],
              "price": {
                  "currency": "USD",
                  "total": "728.06",
                  "base": "663.26",
                  "fees": [
                      {
                          "amount": "0.00",
                          "type": "SUPPLIER"
                      },
                      {
                          "amount": "0.00",
                          "type": "TICKETING"
                      }
                  ],
                  "grandTotal": "728.06"
              },
              "pricingOptions": {
                  "fareType": [
                      "PUBLISHED"
                  ],
                  "includedCheckedBagsOnly": true
              },
              "validatingAirlineCodes": [
                  "AS"
              ],
              "travelerPricings": [
                  {
                      "travelerId": "1",
                      "fareOption": "STANDARD",
                      "travelerType": "ADULT",
                      "price": {
                          "currency": "USD",
                          "total": "728.06",
                          "base": "663.26"
                      },
                      "fareDetailsBySegment": [
                          {
                              "segmentId": "2",
                              "cabin": "BUSINESS",
                              "fareBasis": "VH7TAUFN",
                              "brandedFare": "FR",
                              "brandedFareLabel": "FIRST",
                              "class": "D",
                              "includedCheckedBags": {
                                  "quantity": 2
                              },
                              "amenities": [
                                  {
                                      "description": "SEAT ASSIGNMENT",
                                      "isChargeable": false,
                                      "amenityType": "PRE_RESERVED_SEAT",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "MEAL 1",
                                      "isChargeable": false,
                                      "amenityType": "MEAL",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "PRIORITY BOARDING",
                                      "isChargeable": false,
                                      "amenityType": "TRAVEL_SERVICES",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "110V AC POWER",
                                      "isChargeable": false,
                                      "amenityType": "ENTERTAINMENT",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "USB POWER",
                                      "isChargeable": false,
                                      "amenityType": "ENTERTAINMENT",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "CHANGEABLE TICKET",
                                      "isChargeable": false,
                                      "amenityType": "BRANDED_FARES",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  }
                              ]
                          }
                      ]
                  }
              ]
          },
          "sv_traveler": {
              "id": "1",
              "dateOfBirth": "1982-01-16",
              "name": {
                  "firstName": "JORGE",
                  "lastName": "GONZALES"
              },
              "gender": "MALE",
              "contact": {
                  "emailAddress": "jorge.gonzales833@telefonica.es",
                  "phones": [
                      {
                          "deviceType": "MOBILE",
                          "countryCallingCode": "34",
                          "number": "480080076"
                      }
                  ]
              },
              "documents": [
                  {
                      "documentType": "PASSPORT",
                      "birthPlace": "Madrid",
                      "issuanceLocation": "Madrid",
                      "issuanceDate": "2015-04-14",
                      "number": "00000000",
                      "expiryDate": "2025-04-14",
                      "issuanceCountry": "ES",
                      "validityCountry": "ES",
                      "nationality": "ES",
                      "holder": true
                  }
              ]
          },
          "sv_remark": {
              "general": [
                  {
                      "subType": "GENERAL_MISCELLANEOUS",
                      "text": "ONLINE BOOKING FROM INCREIBLE VIAJES"
                  }
              ]
          },
          "sv_ticketingAgreement": {
              "option": "DELAY_TO_CANCEL",
              "delay": "6D"
          },
          "sv_contact": {
              "addresseeName": {
                  "firstName": "PABLO",
                  "lastName": "RODRIGUEZ"
              },
              "companyName": "INCREIBLE VIAJES",
              "purpose": "STANDARD",
              "phones": [
                  {
                      "deviceType": "LANDLINE",
                      "countryCallingCode": "34",
                      "number": "480080071"
                  },
                  {
                      "deviceType": "MOBILE",
                      "countryCallingCode": "33",
                      "number": "480080072"
                  }
              ],
              "emailAddress": "support@increibleviajes.es",
              "address": {
                  "lines": [
                      "Calle Prado, 16"
                  ],
                  "postalCode": "28014",
                  "cityName": "Madrid",
                  "countryCode": "ES"
              }
          }
      }
      //loder is boolean change in ingest add checkbok
      let py_tp = {
        "id": "1",
        "dateOfBirth": "1982-01-16",
        "name": {
            "firstName": "JORGE",
            "lastName": "GONZALES"
        },
        "gender": "MALE",
        "contact": {
            "emailAddress": "jorge.gonzales833@telefonica.es",
            "phones": [
                {
                    "deviceType": "MOBILE",
                    "countryCallingCode": "34",
                    "number": "480080076"
                }
            ]
        },
        "documents": [
            {
                "documentType": "PASSPORT",
                "birthPlace": "Madrid",
                "issuanceLocation": "Madrid",
                "issuanceDate": "2015-04-14",
                "number": "00000000",
                "expiryDate": "2025-04-14",
                "issuanceCountry": "ES",
                "validityCountry": "ES",
                "nationality": "ES",
                "holder": true
            }
        ]
    }
    if(rqValues.my_data_svdoc){
        
        t = rqValues.my_data_svdoc
        py_tp[ "id"] = t["tid"]
        py_tp[ "dateOfBirth"] = t["dateOfBirth"]
        py_tp[ "gender"] = t["gender"]
        
        
        py_tp["name"][ "firstName"] = t["firstName"]
        py_tp["name"][ "lastName"] = t["lastName"]
        py_tp["contact"][ "emailAddress"] = t["emailAddress"]

        
        let mp = t["memphones"][0]
        if(mp){
            contact_user_phone =py_tp["contact"][ "phones"][0] 
            //populate contact_user_phone
            contact_user_phone["countryCallingCode"] =mp["countryCallingCode"]
            contact_user_phone["number"] =mp["number"]
        }
        
        let mda = t["members"]
       
        if(mda && (mda.length > 0)){
           
            py_tp["documents"] = mda
            let doc = null;
            for(let k=0; k < mda.length; k++){
                doc = mda[k]
                if(doc["holder"] == "Y"){
                    doc["holder"] = true

                }else{
                    doc["holder"] = false
                }
            }
        }
       

        body["sv_traveler"] = py_tp
       
    }else{
     console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
    }
   
      let ambt_tp = {
  
          "dateOfBirth": "1982-01-15",
          "gender": "MALE",
          "documents": [
              {
                  
                  "documentType": "IDENTITY_CARD",
                  "birthPlace": "Madrid",
                  "issuanceLocation": "Madrid",
                  "issuanceDate": "2015-04-13",
                  "documentNumber": "00000069",
                  "expiryDate": "2025-04-13",
                  "issuanceCountry": "ES",
                  "validityCountry": "ES",
                  "nationality": "ES",
                  "holder": "Y"
                 
                  
              }
          ],
          "contact": {
              "emailAddress": "svr@yahoo.com",
              
              "phones": [
                  {
                      
                      "deviceType": "MOBILE",
                      "countryCallingCode": "34",
                     
                      
                      "number": "480080085"
                  }
              ]
          },
          "name": {
              "firstName": "Svbsv",
              "lastName": "Infinity"
          }
      }
      if(rqValues.offer){
          body.sv_offer = rqValues.offer
      }else{
       console.log('SVOCT28***ERROR********* SVWizard not sending offer***********')
      }
     
      if(rqValues.traveller){
          t = rqValues.traveller
          ambt_tp["contact"][ "emailAddress"] = t["email"]
          contact_user_phone =ambt_tp["contact"][ "phones"][0] 
          contact_user_phone["countryCallingCode"] =t["isdcode"]
          contact_user_phone["number"] =t["phone"]

          ambt_tp[ "dateOfBirth"] = t["dateOfBirth"]
          ambt_tp[ "gender"] = t["gender"]
          ambt_tp["name"][ "firstName"] = t["fname"]
          ambt_tp["name"][ "lastName"] = t["lname"]

         
      }else{
       console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
      }
     
     
        const authtoken = `Bearer ${svtv}`
        const svheaders = { 'Authorization': authtoken,
        'Content-Type': 'application/json' };
       
       let body_amcos_tp = {
    
            "dateOfBirth": "1982-01-15",
            "gender": "MALE",
            "documents": [
                {
                    
                    "documentType": "IDENTITY_CARD",
                    "birthPlace": "Madrid",
                    "issuanceLocation": "Madrid",
                    "issuanceDate": "2015-04-13",
                    "documentNumber": "00000069",
                    "expiryDate": "2025-04-13",
                    "issuanceCountry": "ES",
                    "validityCountry": "ES",
                    "nationality": "ES",
                    "holder": "Y"
                   
                    
                }
            ],
            "contact": {
                "emailAddress": "svr@yahoo.com",
                
                "phones": [
                    {
                        
                        "deviceType": "MOBILE",
                        "countryCallingCode": "34",
                       
                        
                        "number": "480080085"
                    }
                ]
            },
            "name": {
                "firstName": "Svbsv",
                "lastName": "Infinity"
            }
        }
        let body_amcos = body_amcos_tp
        if(rqValues.traveller){
            t = rqValues.traveller
            body_amcos["contact"][ "emailAddress"] = t["email"]
            contact_user_phone =body_amcos["contact"][ "phones"][0] 
            if(t["isdcode"] && t["isdcode"].length > 2){
                contact_user_phone["countryCallingCode"] =t["isdcode"]
            }else{
                contact_user_phone["countryCallingCode"] ="1"
            }
            
            contact_user_phone["number"] =t["phone"]
  
            body_amcos[ "dateOfBirth"] = t["dateOfBirth"]
            body_amcos[ "gender"] = t["gender"]
            body_amcos["name"][ "firstName"] = t["fname"]
            body_amcos["name"][ "lastName"] = t["lname"]
  
           
        }else{
         console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
        }
       
       
        axios.all([

            axios.post(url, body, {headers:headers}),
            axios.post(url82, body_amcos,{headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{

                let comData = {
                    "my_data_fly_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                /*sva */
                let crudsuccessob ={
                    "timestamp": "2015-08-23T02:27:18.038+0000",
                    "status": 200,
                    "error": "",
                    "message": "Create Done ",
                    "path": "/kk/svaddressDetailPost"
                }
                comData.crudsuccessob = crudsuccessob
                if(r2.data){
                    console.log('Nov2 **82 save reservation')
                    console.log(r2.data)
                }
                /*svae */
                if(r.data){
                   
                    const ob_ar = r.data
                    const ob = ob_ar[0]
                    const {associatedRecords} = ob
                    if(!ob.reference ){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getPriceAndTexError(eeb))
                    }else{
                        comData.my_data_fly_price_confirmation.confirmationNumber =associatedRecords[0].reference

                        comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_fly_price_confirmation.confirmationNumber
                    

                   
                        dispatch(getPriceAndTexSuccess(comData))
             
                    }
                   
                          }
                else {
                    comData.my_data_fly_price_confirmation.status = "FAILED"
                    comData.my_data_fly_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_fly_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexError(comData))
                }
            })
        ).catch(
            e=>dispatch(getPriceAndTexError(e))
               
        )
     
      
  }

}


export function flypriceAndTexNowSecure_multi_good(rqValues, svtv){
    console.log(rqValues)
    console.log(svtv)
  console.log('%%%%%%%%%%%%%%%sv++++REST API For PY priceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
  return dispatch => {
      dispatch(svflypriceAndTexBegin())
      const urlNewCustomer = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/bbsvbookonebr`
      /*sva */
      const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/airPriceAndTaxReviewMultiEntityMYRESERVATIONSVSecure`
     /*
      const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
      rqValues = {"id":90}
      */
      /*svae*/
      let url  = urlNewCustomer
      let t = null,contact_user_phone = null
      if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
          console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow LATEST**from Microservices DB with 8086 url :' + urlMyReservation)
  
          url = urlMyReservation

      }
      let ui_rq = {
          "offer": {
              "type": "flight-offer",
              "id": "1",
              "source": "GDS",
              "instantTicketingRequired": false,
              "nonHomogeneous": false,
              "paymentCardRequired": false,
              "lastTicketingDate": "2024-10-25",
              "itineraries": [
                  {
                      "segments": [
                          {
                              "departure": {
                                  "iataCode": "EWR",
                                  "terminal": "B",
                                  "at": "2024-11-01T19:29:00"
                              },
                              "arrival": {
                                  "iataCode": "SFO",
                                  "terminal": "1",
                                  "at": "2024-11-01T22:53:00"
                              },
                              "carrierCode": "AS",
                              "number": "295",
                              "aircraft": {
                                  "code": "73H"
                              },
                              "operating": {
                                  "carrierCode": "AS"
                              },
                              "duration": "PT6H24M",
                              "id": "1",
                              "numberOfStops": 0,
                              "co2Emissions": [
                                  {
                                      "weight": 612,
                                      "weightUnit": "KG",
                                      "cabin": "BUSINESS"
                                  }
                              ]
                          }
                      ]
                  }
              ],
              "price": {
                  "currency": "USD",
                  "total": "788.07",
                  "base": "719.07",
                  "fees": [
                      {
                          "amount": "0.00",
                          "type": "SUPPLIER"
                      },
                      {
                          "amount": "0.00",
                          "type": "TICKETING"
                      },
                      {
                          "amount": "0.00",
                          "type": "FORM_OF_PAYMENT"
                      }
                  ],
                  "grandTotal": "788.07",
                  "billingCurrency": "USD"
              },
              "pricingOptions": {
                  "fareType": [
                      "PUBLISHED"
                  ],
                  "includedCheckedBagsOnly": true
              },
              "validatingAirlineCodes": [
                  "AS"
              ],
              "travelerPricings": [
                  {
                      "travelerId": "1",
                      "fareOption": "STANDARD",
                      "travelerType": "ADULT",
                      "price": {
                          "currency": "USD",
                          "total": "788.07",
                          "base": "719.07",
                          "taxes": [
                              {
                                  "amount": "5.00",
                                  "code": "ZP"
                              },
                              {
                                  "amount": "5.60",
                                  "code": "AY"
                              },
                              {
                                  "amount": "53.90",
                                  "code": "US"
                              },
                              {
                                  "amount": "4.50",
                                  "code": "XF"
                              }
                          ],
                          "refundableTaxes": "5.60"
                      },
                      "fareDetailsBySegment": [
                          {
                              "segmentId": "1",
                              "cabin": "BUSINESS",
                              "fareBasis": "VH7OAVFN",
                              "brandedFare": "FR",
                              "class": "D",
                              "includedCheckedBags": {
                                  "quantity": 2
                              }
                          }
                      ]
                  }
              ]
          },
          "product": null,
          "card": {
              "id": "-1",
              "card": "7777123412341234",
              "cvv": "345",
              "mmexp": "03",
              "yyyyexp": "23",
              "otherDetails": "SVMed facility",
              "privateparking": "N",
              "rentcar": "N",
              "bookTaxi": "N",
              "needFlight": "N",
              "cardId": "-4",
              "cardNumber": "7777777777777777",
              "gene": "77771234--1234--1234"
          },
          "traveller": {
              "id": "-1",
              "gene": "1",
              "fname": "alen",
              "lname": "sim",
              "email": "alen@sv.com",
              "address": "12 lin",
              "city": "san jose",
              "state": "CA",
              "zip": "95020",
              "country": "usa",
              "isdcode": "1",
              "phone": "4081231234",
              "bookingAgentType": "S",
              "traveType": "P",
              "specialRequests": "Wheel chair and Senior Citizen",
              "card": "1234-1234--1234--1234",
              "cvv": "Glen",
              "mmexp": "04",
              "yyyyexp": "2028",
              "addressId": 36,
              "customerId": 36,
              "name": "alen beta",
              "login": "alenb",
              "password": null,
              "otherDetails": "need pickup",
              "zipcode": "99999",
              "addressType": "B",
              "createdDate": null,
              "modifiedDate": null,
              "createdBy": null,
              "modifiedBy": null
          },
          "reservationAirProduct": {
              "productCategoryCode": 5,
              "productName": "AlaskaVacationKate57",
              "productDetails": "AlaskaVacationKate57",
              "description": "Alaska Kate57",
              "producttype": "svr",
              "flight_space_id": 13,
              "flight_space_key": "1@4@1@adq",
              "sale_ind": "Y",
              "vernacularcode": "en",
              "sojourncode": "RMC",
              "startdate": "2023-11-24",
              "enddate": "2026-12-01",
              "commoditytype": "RMc",
              "companycode": "SVR",
              "week": 11,
              "year": 24,
              "exchange_value": 12,
              "season": "RED",
              "bkgrnd_srch_sw": "Y",
              "pool": "NAMER",
              "maxoccupancy": "2",
              "flight_rack_rate": 23,
              "webStatusFlag": "Y",
              "srciata": "09a",
              "dstiata": "adq",
              "airlinesNameIata": "2o",
              "airlinesCodeIata": 4,
              "flightAirlineNumStops": 1,
              "flightDepartureTimeTzest": "2025-10-25t10:30:00-0400",
              "flightArrivalTimeTzest": "2025-10-26t16:30:00-0400",
              "flightOperatedBy": "4009 operated by envoy airlines",
              "flightOperatedOwned": "y",
              "flightTimeHhmm": "6hr 29min",
              "svCleanupColPending": "Y",
              "flightid": 57,
              "languagecode": "en",
              "svrtypeid": "SVR"
          },
          "meta": {
              "addressId": 36,
              "customerId": 36,
              "cardId": -1
          }
      }
      let body = {
          "sv_offer": {
              "type": "flight-offer",
              "id": "1",
              "source": "GDS",
              "instantTicketingRequired": false,
              "nonHomogeneous": false,
              "oneWay": false,
              "isUpsellOffer": false,
              "lastTicketingDate": "2024-10-25",
              "lastTicketingDateTime": "2024-10-25",
              "numberOfBookableSeats": 7,
              "itineraries": [
                  {
                      "duration": "PT6H11M",
                      "segments": [
                          {
                              "departure": {
                                  "iataCode": "EWR",
                                  "terminal": "B",
                                  "at": "2024-11-01T19:59:00"
                              },
                              "arrival": {
                                  "iataCode": "LAX",
                                  "terminal": "6",
                                  "at": "2024-11-01T23:10:00"
                              },
                              "carrierCode": "AS",
                              "number": "287",
                              "aircraft": {
                                  "code": "7M9"
                              },
                              "operating": {
                                  "carrierCode": "AS"
                              },
                              "duration": "PT6H11M",
                              "id": "2",
                              "numberOfStops": 0,
                              "blacklistedInEU": false
                          }
                      ]
                  }
              ],
              "price": {
                  "currency": "USD",
                  "total": "728.06",
                  "base": "663.26",
                  "fees": [
                      {
                          "amount": "0.00",
                          "type": "SUPPLIER"
                      },
                      {
                          "amount": "0.00",
                          "type": "TICKETING"
                      }
                  ],
                  "grandTotal": "728.06"
              },
              "pricingOptions": {
                  "fareType": [
                      "PUBLISHED"
                  ],
                  "includedCheckedBagsOnly": true
              },
              "validatingAirlineCodes": [
                  "AS"
              ],
              "travelerPricings": [
                  {
                      "travelerId": "1",
                      "fareOption": "STANDARD",
                      "travelerType": "ADULT",
                      "price": {
                          "currency": "USD",
                          "total": "728.06",
                          "base": "663.26"
                      },
                      "fareDetailsBySegment": [
                          {
                              "segmentId": "2",
                              "cabin": "BUSINESS",
                              "fareBasis": "VH7TAUFN",
                              "brandedFare": "FR",
                              "brandedFareLabel": "FIRST",
                              "class": "D",
                              "includedCheckedBags": {
                                  "quantity": 2
                              },
                              "amenities": [
                                  {
                                      "description": "SEAT ASSIGNMENT",
                                      "isChargeable": false,
                                      "amenityType": "PRE_RESERVED_SEAT",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "MEAL 1",
                                      "isChargeable": false,
                                      "amenityType": "MEAL",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "PRIORITY BOARDING",
                                      "isChargeable": false,
                                      "amenityType": "TRAVEL_SERVICES",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "110V AC POWER",
                                      "isChargeable": false,
                                      "amenityType": "ENTERTAINMENT",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "USB POWER",
                                      "isChargeable": false,
                                      "amenityType": "ENTERTAINMENT",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  },
                                  {
                                      "description": "CHANGEABLE TICKET",
                                      "isChargeable": false,
                                      "amenityType": "BRANDED_FARES",
                                      "amenityProvider": {
                                          "name": "BrandedFare"
                                      }
                                  }
                              ]
                          }
                      ]
                  }
              ]
          },
          "sv_traveler": {
              "id": "1",
              "dateOfBirth": "1982-01-16",
              "name": {
                  "firstName": "JORGE",
                  "lastName": "GONZALES"
              },
              "gender": "MALE",
              "contact": {
                  "emailAddress": "jorge.gonzales833@telefonica.es",
                  "phones": [
                      {
                          "deviceType": "MOBILE",
                          "countryCallingCode": "34",
                          "number": "480080076"
                      }
                  ]
              },
              "documents": [
                  {
                      "documentType": "PASSPORT",
                      "birthPlace": "Madrid",
                      "issuanceLocation": "Madrid",
                      "issuanceDate": "2015-04-14",
                      "number": "00000000",
                      "expiryDate": "2025-04-14",
                      "issuanceCountry": "ES",
                      "validityCountry": "ES",
                      "nationality": "ES",
                      "holder": true
                  }
              ]
          },
          "sv_remark": {
              "general": [
                  {
                      "subType": "GENERAL_MISCELLANEOUS",
                      "text": "ONLINE BOOKING FROM INCREIBLE VIAJES"
                  }
              ]
          },
          "sv_ticketingAgreement": {
              "option": "DELAY_TO_CANCEL",
              "delay": "6D"
          },
          "sv_contact": {
              "addresseeName": {
                  "firstName": "PABLO",
                  "lastName": "RODRIGUEZ"
              },
              "companyName": "INCREIBLE VIAJES",
              "purpose": "STANDARD",
              "phones": [
                  {
                      "deviceType": "LANDLINE",
                      "countryCallingCode": "34",
                      "number": "480080071"
                  },
                  {
                      "deviceType": "MOBILE",
                      "countryCallingCode": "33",
                      "number": "480080072"
                  }
              ],
              "emailAddress": "support@increibleviajes.es",
              "address": {
                  "lines": [
                      "Calle Prado, 16"
                  ],
                  "postalCode": "28014",
                  "cityName": "Madrid",
                  "countryCode": "ES"
              }
          }
      }
      //loder is boolean change in ingest add checkbok
      let py_tp = {
        "id": "1",
        "dateOfBirth": "1982-01-16",
        "name": {
            "firstName": "JORGE",
            "lastName": "GONZALES"
        },
        "gender": "MALE",
        "contact": {
            "emailAddress": "jorge.gonzales833@telefonica.es",
            "phones": [
                {
                    "deviceType": "MOBILE",
                    "countryCallingCode": "34",
                    "number": "480080076"
                }
            ]
        },
        "documents": [
            {
                "documentType": "PASSPORT",
                "birthPlace": "Madrid",
                "issuanceLocation": "Madrid",
                "issuanceDate": "2015-04-14",
                "number": "00000000",
                "expiryDate": "2025-04-14",
                "issuanceCountry": "ES",
                "validityCountry": "ES",
                "nationality": "ES",
                "holder": true
            }
        ]
    }
    if(rqValues.traveller){
        t = rqValues.traveller
        py_tp["contact"][ "emailAddress"] = t["email"]
        contact_user_phone =py_tp["contact"][ "phones"][0] 
        contact_user_phone["countryCallingCode"] =t["isdcode"]
        contact_user_phone["number"] =t["phone"]

        py_tp[ "dateOfBirth"] = t["dateOfBirth"]
        py_tp[ "gender"] = t["gender"]
        py_tp["name"][ "firstName"] = t["fname"]
        py_tp["name"][ "lastName"] = t["lname"]

        body["sv_traveler"] = py_tp

       
    }else{
     console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
    }
   
      let ambt_tp = {
  
          "dateOfBirth": "1982-01-15",
          "gender": "MALE",
          "documents": [
              {
                  
                  "documentType": "IDENTITY_CARD",
                  "birthPlace": "Madrid",
                  "issuanceLocation": "Madrid",
                  "issuanceDate": "2015-04-13",
                  "documentNumber": "00000069",
                  "expiryDate": "2025-04-13",
                  "issuanceCountry": "ES",
                  "validityCountry": "ES",
                  "nationality": "ES",
                  "holder": "Y"
                 
                  
              }
          ],
          "contact": {
              "emailAddress": "svr@yahoo.com",
              
              "phones": [
                  {
                      
                      "deviceType": "MOBILE",
                      "countryCallingCode": "34",
                     
                      
                      "number": "480080085"
                  }
              ]
          },
          "name": {
              "firstName": "Svbsv",
              "lastName": "Infinity"
          }
      }
      if(rqValues.offer){
          body.sv_offer = rqValues.offer
      }else{
       console.log('SVOCT28***ERROR********* SVWizard not sending offer***********')
      }
     
      if(rqValues.traveller){
          t = rqValues.traveller
          ambt_tp["contact"][ "emailAddress"] = t["email"]
          contact_user_phone =ambt_tp["contact"][ "phones"][0] 
          contact_user_phone["countryCallingCode"] =t["isdcode"]
          contact_user_phone["number"] =t["phone"]

          ambt_tp[ "dateOfBirth"] = t["dateOfBirth"]
          ambt_tp[ "gender"] = t["gender"]
          ambt_tp["name"][ "firstName"] = t["fname"]
          ambt_tp["name"][ "lastName"] = t["lname"]

         
      }else{
       console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
      }
     
      /*
     // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
      
     const body = {
          card : {
              "card": "1234-1234--1234--1234",
              "cvv": "Glen",
              "mmexp": "04",
              "yyyyexp": "2028"
          },
          traveller: {
              "id": "addLeft_step",
              "gene": "addLeft_step",
              "dcountry": "China",
              "privateparking":false,
              "rentcar":false,
              "bookTaxi":false,
              "needFlight":false,
              "arrivalTimeZone":"tz_pst",
              "fname": "John",
              "lname": "Glen",
              "email": "john123@yahoo.com",
              "address": "Glen",
              "city": "Glen",
              "state": "Glen",
              "zip": "12110",
              "country": "Glen",
              "isdcode": "+1",
              "phone": "Glen",
              "bookingAgentType": "self",
              "traveType": "Personal",
              "specialRequests": "Wheel chair and Senior Citizen",
              "gname": "Glen",
              "gemail": "Glen@yahoo.com",
              "card": "1234-1234--1234--1234",
              "cvv": "Glen",
              "mmexp": "04",
              "yyyyexp": "2028"
          }
        } 
        */
        const authtoken = `Bearer ${svtv}`
        const svheaders = { 'Authorization': authtoken,
        'Content-Type': 'application/json' };
        let url82 = 'http://localhost:8082/amcos/createFull'
        let body_amcos_tp = {
    
            "dateOfBirth": "1982-01-15",
            "gender": "MALE",
            "documents": [
                {
                    
                    "documentType": "IDENTITY_CARD",
                    "birthPlace": "Madrid",
                    "issuanceLocation": "Madrid",
                    "issuanceDate": "2015-04-13",
                    "documentNumber": "00000069",
                    "expiryDate": "2025-04-13",
                    "issuanceCountry": "ES",
                    "validityCountry": "ES",
                    "nationality": "ES",
                    "holder": "Y"
                   
                    
                }
            ],
            "contact": {
                "emailAddress": "svr@yahoo.com",
                
                "phones": [
                    {
                        
                        "deviceType": "MOBILE",
                        "countryCallingCode": "34",
                       
                        
                        "number": "480080085"
                    }
                ]
            },
            "name": {
                "firstName": "Svbsv",
                "lastName": "Infinity"
            }
        }
        let body_amcos = body_amcos_tp
        if(rqValues.traveller){
            t = rqValues.traveller
            body_amcos["contact"][ "emailAddress"] = t["email"]
            contact_user_phone =body_amcos["contact"][ "phones"][0] 
            if(t["isdcode"] && t["isdcode"].length > 2){
                contact_user_phone["countryCallingCode"] =t["isdcode"]
            }else{
                contact_user_phone["countryCallingCode"] ="1"
            }
            
            contact_user_phone["number"] =t["phone"]
  
            body_amcos[ "dateOfBirth"] = t["dateOfBirth"]
            body_amcos[ "gender"] = t["gender"]
            body_amcos["name"][ "firstName"] = t["fname"]
            body_amcos["name"][ "lastName"] = t["lname"]
  
           
        }else{
         console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
        }
       
       
        axios.all([

            axios.post(url, body, {headers:headers}),
            axios.post(url82, body_amcos,{headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{

                let comData = {
                    "my_data_fly_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                /*sva */
                let crudsuccessob ={
                    "timestamp": "2015-08-23T02:27:18.038+0000",
                    "status": 200,
                    "error": "",
                    "message": "Create Done ",
                    "path": "/kk/svaddressDetailPost"
                }
                comData.crudsuccessob = crudsuccessob
                if(r2.data){
                    console.log('Nov2 **82 save reservation')
                    console.log(r2.data)
                }
                /*svae */
                if(r.data){
                   
                    const ob_ar = r.data
                    const ob = ob_ar[0]
                    const {associatedRecords} = ob
                    if(!ob.reference ){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getPriceAndTexError(eeb))
                    }else{
                        comData.my_data_fly_price_confirmation.confirmationNumber =associatedRecords[0].reference

                        comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_fly_price_confirmation.confirmationNumber
                    

                   
                        dispatch(getPriceAndTexSuccess(comData))
             
                    }
                   
                          }
                else {
                    comData.my_data_fly_price_confirmation.status = "FAILED"
                    comData.my_data_fly_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_fly_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexError(comData))
                }
            })
        ).catch(
            e=>dispatch(getPriceAndTexError(e))
               
        )
     
      
  }

}


  export function flypriceAndTexNowSecure_org(rqValues, svtv){
      console.log(rqValues)
      console.log(svtv)
    console.log('%%%%%%%%%%%%%%%sv++++REST API For PY priceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svflypriceAndTexBegin())
        const urlNewCustomer = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/bbsvbookonebr`
        /*sva */
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/airPriceAndTaxReviewMultiEntityMYRESERVATIONSVSecure`
       /*
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
        rqValues = {"id":90}
        */
        /*svae*/
        let url  = urlNewCustomer
        if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
            console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow LATEST**from Microservices DB with 8086 url :' + urlMyReservation)
    
            url = urlMyReservation

        }
        let ui_rq = {
            "offer": {
                "type": "flight-offer",
                "id": "1",
                "source": "GDS",
                "instantTicketingRequired": false,
                "nonHomogeneous": false,
                "paymentCardRequired": false,
                "lastTicketingDate": "2024-10-25",
                "itineraries": [
                    {
                        "segments": [
                            {
                                "departure": {
                                    "iataCode": "EWR",
                                    "terminal": "B",
                                    "at": "2024-11-01T19:29:00"
                                },
                                "arrival": {
                                    "iataCode": "SFO",
                                    "terminal": "1",
                                    "at": "2024-11-01T22:53:00"
                                },
                                "carrierCode": "AS",
                                "number": "295",
                                "aircraft": {
                                    "code": "73H"
                                },
                                "operating": {
                                    "carrierCode": "AS"
                                },
                                "duration": "PT6H24M",
                                "id": "1",
                                "numberOfStops": 0,
                                "co2Emissions": [
                                    {
                                        "weight": 612,
                                        "weightUnit": "KG",
                                        "cabin": "BUSINESS"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "price": {
                    "currency": "USD",
                    "total": "788.07",
                    "base": "719.07",
                    "fees": [
                        {
                            "amount": "0.00",
                            "type": "SUPPLIER"
                        },
                        {
                            "amount": "0.00",
                            "type": "TICKETING"
                        },
                        {
                            "amount": "0.00",
                            "type": "FORM_OF_PAYMENT"
                        }
                    ],
                    "grandTotal": "788.07",
                    "billingCurrency": "USD"
                },
                "pricingOptions": {
                    "fareType": [
                        "PUBLISHED"
                    ],
                    "includedCheckedBagsOnly": true
                },
                "validatingAirlineCodes": [
                    "AS"
                ],
                "travelerPricings": [
                    {
                        "travelerId": "1",
                        "fareOption": "STANDARD",
                        "travelerType": "ADULT",
                        "price": {
                            "currency": "USD",
                            "total": "788.07",
                            "base": "719.07",
                            "taxes": [
                                {
                                    "amount": "5.00",
                                    "code": "ZP"
                                },
                                {
                                    "amount": "5.60",
                                    "code": "AY"
                                },
                                {
                                    "amount": "53.90",
                                    "code": "US"
                                },
                                {
                                    "amount": "4.50",
                                    "code": "XF"
                                }
                            ],
                            "refundableTaxes": "5.60"
                        },
                        "fareDetailsBySegment": [
                            {
                                "segmentId": "1",
                                "cabin": "BUSINESS",
                                "fareBasis": "VH7OAVFN",
                                "brandedFare": "FR",
                                "class": "D",
                                "includedCheckedBags": {
                                    "quantity": 2
                                }
                            }
                        ]
                    }
                ]
            },
            "product": null,
            "card": {
                "id": "-1",
                "card": "7777123412341234",
                "cvv": "345",
                "mmexp": "03",
                "yyyyexp": "23",
                "otherDetails": "SVMed facility",
                "privateparking": "N",
                "rentcar": "N",
                "bookTaxi": "N",
                "needFlight": "N",
                "cardId": "-4",
                "cardNumber": "7777777777777777",
                "gene": "77771234--1234--1234"
            },
            "traveller": {
                "id": "-1",
                "gene": "1",
                "fname": "alen",
                "lname": "sim",
                "email": "alen@sv.com",
                "address": "12 lin",
                "city": "san jose",
                "state": "CA",
                "zip": "95020",
                "country": "usa",
                "isdcode": "1",
                "phone": "4081231234",
                "bookingAgentType": "S",
                "traveType": "P",
                "specialRequests": "Wheel chair and Senior Citizen",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028",
                "addressId": 36,
                "customerId": 36,
                "name": "alen beta",
                "login": "alenb",
                "password": null,
                "otherDetails": "need pickup",
                "zipcode": "99999",
                "addressType": "B",
                "createdDate": null,
                "modifiedDate": null,
                "createdBy": null,
                "modifiedBy": null
            },
            "reservationAirProduct": {
                "productCategoryCode": 5,
                "productName": "AlaskaVacationKate57",
                "productDetails": "AlaskaVacationKate57",
                "description": "Alaska Kate57",
                "producttype": "svr",
                "flight_space_id": 13,
                "flight_space_key": "1@4@1@adq",
                "sale_ind": "Y",
                "vernacularcode": "en",
                "sojourncode": "RMC",
                "startdate": "2023-11-24",
                "enddate": "2026-12-01",
                "commoditytype": "RMc",
                "companycode": "SVR",
                "week": 11,
                "year": 24,
                "exchange_value": 12,
                "season": "RED",
                "bkgrnd_srch_sw": "Y",
                "pool": "NAMER",
                "maxoccupancy": "2",
                "flight_rack_rate": 23,
                "webStatusFlag": "Y",
                "srciata": "09a",
                "dstiata": "adq",
                "airlinesNameIata": "2o",
                "airlinesCodeIata": 4,
                "flightAirlineNumStops": 1,
                "flightDepartureTimeTzest": "2025-10-25t10:30:00-0400",
                "flightArrivalTimeTzest": "2025-10-26t16:30:00-0400",
                "flightOperatedBy": "4009 operated by envoy airlines",
                "flightOperatedOwned": "y",
                "flightTimeHhmm": "6hr 29min",
                "svCleanupColPending": "Y",
                "flightid": 57,
                "languagecode": "en",
                "svrtypeid": "SVR"
            },
            "meta": {
                "addressId": 36,
                "customerId": 36,
                "cardId": -1
            }
        }
        let body = {
            "sv_offer": {
                "type": "flight-offer",
                "id": "1",
                "source": "GDS",
                "instantTicketingRequired": false,
                "nonHomogeneous": false,
                "oneWay": false,
                "isUpsellOffer": false,
                "lastTicketingDate": "2024-10-25",
                "lastTicketingDateTime": "2024-10-25",
                "numberOfBookableSeats": 7,
                "itineraries": [
                    {
                        "duration": "PT6H11M",
                        "segments": [
                            {
                                "departure": {
                                    "iataCode": "EWR",
                                    "terminal": "B",
                                    "at": "2024-11-01T19:59:00"
                                },
                                "arrival": {
                                    "iataCode": "LAX",
                                    "terminal": "6",
                                    "at": "2024-11-01T23:10:00"
                                },
                                "carrierCode": "AS",
                                "number": "287",
                                "aircraft": {
                                    "code": "7M9"
                                },
                                "operating": {
                                    "carrierCode": "AS"
                                },
                                "duration": "PT6H11M",
                                "id": "2",
                                "numberOfStops": 0,
                                "blacklistedInEU": false
                            }
                        ]
                    }
                ],
                "price": {
                    "currency": "USD",
                    "total": "728.06",
                    "base": "663.26",
                    "fees": [
                        {
                            "amount": "0.00",
                            "type": "SUPPLIER"
                        },
                        {
                            "amount": "0.00",
                            "type": "TICKETING"
                        }
                    ],
                    "grandTotal": "728.06"
                },
                "pricingOptions": {
                    "fareType": [
                        "PUBLISHED"
                    ],
                    "includedCheckedBagsOnly": true
                },
                "validatingAirlineCodes": [
                    "AS"
                ],
                "travelerPricings": [
                    {
                        "travelerId": "1",
                        "fareOption": "STANDARD",
                        "travelerType": "ADULT",
                        "price": {
                            "currency": "USD",
                            "total": "728.06",
                            "base": "663.26"
                        },
                        "fareDetailsBySegment": [
                            {
                                "segmentId": "2",
                                "cabin": "BUSINESS",
                                "fareBasis": "VH7TAUFN",
                                "brandedFare": "FR",
                                "brandedFareLabel": "FIRST",
                                "class": "D",
                                "includedCheckedBags": {
                                    "quantity": 2
                                },
                                "amenities": [
                                    {
                                        "description": "SEAT ASSIGNMENT",
                                        "isChargeable": false,
                                        "amenityType": "PRE_RESERVED_SEAT",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "MEAL 1",
                                        "isChargeable": false,
                                        "amenityType": "MEAL",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "PRIORITY BOARDING",
                                        "isChargeable": false,
                                        "amenityType": "TRAVEL_SERVICES",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "110V AC POWER",
                                        "isChargeable": false,
                                        "amenityType": "ENTERTAINMENT",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "USB POWER",
                                        "isChargeable": false,
                                        "amenityType": "ENTERTAINMENT",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "CHANGEABLE TICKET",
                                        "isChargeable": false,
                                        "amenityType": "BRANDED_FARES",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "sv_traveler": {
                "id": "1",
                "dateOfBirth": "1982-01-16",
                "name": {
                    "firstName": "JORGE",
                    "lastName": "GONZALES"
                },
                "gender": "MALE",
                "contact": {
                    "emailAddress": "jorge.gonzales833@telefonica.es",
                    "phones": [
                        {
                            "deviceType": "MOBILE",
                            "countryCallingCode": "34",
                            "number": "480080076"
                        }
                    ]
                },
                "documents": [
                    {
                        "documentType": "PASSPORT",
                        "birthPlace": "Madrid",
                        "issuanceLocation": "Madrid",
                        "issuanceDate": "2015-04-14",
                        "number": "00000000",
                        "expiryDate": "2025-04-14",
                        "issuanceCountry": "ES",
                        "validityCountry": "ES",
                        "nationality": "ES",
                        "holder": true
                    }
                ]
            },
            "sv_remark": {
                "general": [
                    {
                        "subType": "GENERAL_MISCELLANEOUS",
                        "text": "ONLINE BOOKING FROM INCREIBLE VIAJES"
                    }
                ]
            },
            "sv_ticketingAgreement": {
                "option": "DELAY_TO_CANCEL",
                "delay": "6D"
            },
            "sv_contact": {
                "addresseeName": {
                    "firstName": "PABLO",
                    "lastName": "RODRIGUEZ"
                },
                "companyName": "INCREIBLE VIAJES",
                "purpose": "STANDARD",
                "phones": [
                    {
                        "deviceType": "LANDLINE",
                        "countryCallingCode": "34",
                        "number": "480080071"
                    },
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "33",
                        "number": "480080072"
                    }
                ],
                "emailAddress": "support@increibleviajes.es",
                "address": {
                    "lines": [
                        "Calle Prado, 16"
                    ],
                    "postalCode": "28014",
                    "cityName": "Madrid",
                    "countryCode": "ES"
                }
            }
        }
        let ambt_tp = {
    
            "dateOfBirth": "1982-01-15",
            "gender": "MALE",
            "documents": [
                {
                    
                    "documentType": "IDENTITY_CARD",
                    "birthPlace": "Madrid",
                    "issuanceLocation": "Madrid",
                    "issuanceDate": "2015-04-13",
                    "documentNumber": "00000069",
                    "expiryDate": "2025-04-13",
                    "issuanceCountry": "ES",
                    "validityCountry": "ES",
                    "nationality": "ES",
                    "holder": "Y"
                   
                    
                }
            ],
            "contact": {
                "emailAddress": "svr@yahoo.com",
                
                "phones": [
                    {
                        
                        "deviceType": "MOBILE",
                        "countryCallingCode": "34",
                       
                        
                        "number": "480080085"
                    }
                ]
            },
            "name": {
                "firstName": "Svbsv",
                "lastName": "Infinity"
            }
        }
        if(rqValues.offer){
            body.sv_offer = rqValues.offer
        }else{
         console.log('SVOCT28***ERROR********* SVWizard not sending offer***********')
        }
        let t = null, contact_user_phone = null
        if(rqValues.traveller){
            t = rqValues.traveller
            ambt_tp["contact"][ "emailAddress"] = t["email"]
            contact_user_phone =ambt_tp["contact"][ "phones"][0] 
            contact_user_phone["countryCallingCode"] =t["isdcode"]
            contact_user_phone["number"] =t["phone"]

            ambt_tp[ "dateOfBirth"] = t["dateOfBirth"]
            ambt_tp[ "gender"] = t["gender"]
            ambt_tp["name"][ "firstName"] = t["fname"]
            ambt_tp["name"][ "lastName"] = t["lname"]

           
        }else{
         console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
        }
       
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
          const authtoken = `Bearer ${svtv}`
          const svheaders = { 'Authorization': authtoken,
          'Content-Type': 'application/json' };
       
        
        axios.post(url, body, {headers:svheaders})
        .then(
            r => {
                let comData = {
                    "my_data_fly_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                /*sva */
                let crudsuccessob ={
                    "timestamp": "2015-08-23T02:27:18.038+0000",
                    "status": 200,
                    "error": "",
                    "message": "Create Done ",
                    "path": "/kk/svaddressDetailPost"
                }
                comData.crudsuccessob = crudsuccessob

                /*svae */
                if(r.data){
                   
                    const ob_ar = r.data
                    const ob = ob_ar[0]
                    const {associatedRecords} = ob
                    if(!ob.reference ){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getPriceAndTexError(eeb))
                    }else{
                        comData.my_data_fly_price_confirmation.confirmationNumber =associatedRecords[0].reference

                        comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_fly_price_confirmation.confirmationNumber
                    

                   
                        dispatch(getPriceAndTexSuccess(comData))
             
                    }
                   
                          }
                else {
                    comData.my_data_fly_price_confirmation.status = "FAILED"
                    comData.my_data_fly_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_fly_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexError(comData))
                }
            }
        ).catch(
            
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}

  export function flypriceAndTexNow(rqValues,hdr, relUrl){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For flypriceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svflypriceAndTexBegin())
        const urlNewCustomer = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/airPriceAndTaxReviewMultiEntity`
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/airPriceAndTaxReviewMultiEntityMYRESERVATIONSV`
        let url  = urlNewCustomer
        console.log('sv** new reservation flight ')
        console.log('sv** new reservation flight body ')

        console.log(rqValues)
        if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
            console.log('sv** existing myreservation flight ')
            url = urlMyReservation
        }
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
    "reservationAirProduct": {
        "productCategoryCode": 5,
        "productName": "AlaskaVacationKate57",
        "productDetails": "AlaskaVacationKate57",
        "description": "Alaska Kate57",
        "producttype": "svr",
        "flight_space_id": 57,
        "flight_space_key": "57@1515@81@BLD",
        "sale_ind": "Y",
        "vernacularcode": "en",
        "sojourncode": "RM41",
        "startdate": "2024-11-24",
        "enddate": "2026-11-24",
        "commoditytype": "RMc",
        "companycode": "SVR",
        "week": 11,
        "year": 24,
        "exchange_value": 12,
        "season": "RED",
       
        "bkgrnd_srch_sw": "Y",
        "pool": "NAMER",
        "maxoccupancy": "2",
        "flight_rack_rate": 23,
        "webStatusFlag": "Y",
       

       
        
        "srciata": "81",
        "dstiata": "BLD",
        "airlinesNameIata": "YR",
        "airlinesCodeIata": 1514,
        "flightAirlineNumStops": 1,
        "flightDepartureTimeTzest": "2024-08-18T05:08:08+0630",
        "flightArrivalTimeTzest": "2024-09-18T05:08:08+0630",
        "flightOperatedBy": "4009  Envoy Airlines",
        "flightOperatedOwned": "Y",
        "flightTimeHhmm": "6hr 29min",
        "svCleanupColPending": "Y",
        "flightid": 57,
        "languagecode": "en",
        
       
       
      
       
       
        "svrtypeid": "SVR"
        
       
        


       
    },
    "card": {
        "id": true,
        "gene": "27",
        "card": "123412341234",
        "cvv": "345",
        "mmexp": "08",
        "yyyyexp": "37",
        "arrivalTimeZone": "tz_pst",
        "privateparking": "Y",
        "bookTaxi": "Y",
        "needFlight": "Y",
        "rentcar": "N",
        "otherDetails": "UI HardCoded SVMed facility"
    },
    "traveller": {
        "id": "1",
        "fname": "Kate57",
        "lname": "mer",
        "email": "Kate57@yahoo.com",
        "address": "12",
        "city": "san",
        "zip": "95050",
        "isdcode": "1",
        "phone": "9031231234",
        "bookingAgentType": "S",
        "traveType": "B",
        "gname": "Kate57",
        "gemail": "Kate57@yahoo.com",
        "state": "CA"
    }
}
          */
          const svurl = relUrl ? `${SV_SOJ_ORCMOCK_ADDRESS}/${relUrl}` :url
          const svhdr = hdr ? hdr: headers 
        
        axios.post(svurl, rqValues, {headers:svhdr})
        .then(
            r => {
                let comData = {
                    "my_data_fly_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                if(r.data){
                   const {reservation} = r.data
                   if(reservation && reservation.reservationConfirmCode	){
                       
                    comData.my_data_fly_price_confirmation.confirmationNumber = reservation.reservationConfirmCode
                   }else{
                   // comData.my_data_fly_price_confirmation = r.data
                   }
                    
                    

                   
                    dispatch(getPriceAndTexSuccess(comData))
                }
                else {
                    comData.my_data_fly_price_confirmation.status = "FAILED"
                    comData.my_data_fly_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_fly_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}



export function flypriceAndTexNowSecure_old(rqValues, svtv){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svflypriceAndTexBegin())
        const urlNewCustomer = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/airPriceAndTaxReviewMultiEntity`
        /*sva */
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/airPriceAndTaxReviewMultiEntityMYRESERVATIONSVSecure`
       /*
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
        rqValues = {"id":90}
        */
        /*svae*/
        let url  = urlNewCustomer
        if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
            console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow LATEST**from Microservices DB with 8086 url :' + urlMyReservation)
    
            url = urlMyReservation

        }
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
          const authtoken = `Bearer ${svtv}`
          const svheaders = { 'Authorization': authtoken,
          'Content-Type': 'application/json' };
       
        
        axios.post(url, rqValues, {headers:svheaders})
        .then(
            r => {
                let comData = {
                    "my_data_fly_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                /*sva */
                let crudsuccessob ={
                    "timestamp": "2015-08-23T02:27:18.038+0000",
                    "status": 200,
                    "error": "",
                    "message": "Create Done ",
                    "path": "/kk/svaddressDetailPost"
                }
                comData.crudsuccessob = crudsuccessob

                /*svae */
                if(r.data){
                   
                    const ob = r.data
                    if(ob.status && ob.status !=200){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getPriceAndTexError(eeb))
                    }else{
                        comData.my_data_fly_price_confirmation = r.data
                        comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_fly_price_confirmation.confirmationNumber
                    

                   
                        dispatch(getPriceAndTexSuccess(comData))
             
                    }
                   
                          }
                else {
                    comData.my_data_fly_price_confirmation.status = "FAILED"
                    comData.my_data_fly_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_fly_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexError(comData))
                }
            }
        ).catch(
            
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}
export function flypriceAndTexNowSingle(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For flypriceAndTexNowSingle from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svflypriceAndTexBegin())
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spacePriceAndTaxReview`
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                let comData = {
                    "my_data_fly_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   
                    comData.my_data_fly_price_confirmation = r.data
                    

                   
                    dispatch(getPriceAndTexSuccess(comData))
                }
                else {
                    comData.my_data_fly_price_confirmation.status = "FAILED"
                    comData.my_data_fly_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_fly_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}

export const svflypriceAndTexBegin = () => dispatch => {
    dispatch({
        type:typesFlyreview.GET_FLY_PRICEANDTAX_BEGIN
        
    })
}
export const svFlyLoadReviewBegin = () => dispatch => {
    dispatch({
        type:'GET_FLYREVIEW_BEGIN'
        
    })
}


export const getPriceAndTexSuccess = (data) => dispatch => {
    dispatch({
        type: typesFlyreview.GET_FLY_PRICEANDTAX_SUCCESS,
        payload: data
    })
}
export const flySaveTravellerReviewSuccess = (dataOb) => dispatch => {
    dispatch({
        type: 'SAVETRAVELLER_FLYREVIEW_SUCCESS',
        payload: dataOb
    })
}


export const flySaveTocumentReviewSuccessSVBakNov20 = (dataOb) => dispatch => {
    //we have mo object lets fix that
    
    dispatch({
        type: 'SAVETOCUMENT_FLYREVIEW_SUCCESS',
        payload: dataOb
    })
}
export const flySaveDocumentReviewSuccess = (dataOb) => dispatch => {
    dispatch({
        type: 'SAVEDOCUMENT_FLYREVIEW_SUCCESS',
        payload: dataOb
    })
}

export const geLoadAddressDataDBCustSuccess = (data) => dispatch => {
    dispatch({
        id:-1,
        type:typesFlyreview.FLYMYRESERVATIONS_PRIMARY_ADDRESS_LOAD_SUCCESS_DO_NOTHING || 'FLYMYRESERVATIONS_PRIMARY_ADDRESS_LOAD_SUCCESS_DO_NOTHING',
        payload: data
    })
}

export const getFlyLoadReviewSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_FLYREVIEW_SUCCESS',
        payload: data
    })
}

export const getFlyLoadReviewNyReservationCustSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_FLYREVIEW_MYRESERVATION_SV_SUCCESS',
        payload: data
    })
}





export const getPriceAndTexError = (e) =>dispatch => {
    console.log('pricetax error')
    console.log(e)
    dispatch({
        type:typesFlyreview.GET_FLY_PRICEANDTAX_ERROR,
        /*sva  error:e*/
        payload:e
        /*svae*/
    })
}
//getOfferReviewError
export const getLoadReviewError = (e) =>dispatch => {
    dispatch({
        type:'GET_FLYREVIEW_ERROR',
        error:e
       
    })
}

export const getOfferReviewError = (eob) =>dispatch => {
    dispatch({
        type:'GET_OFFERREVIEW_ERROR',
        payload:eob
    })
}

export const svFlyLoadReviewdetReset = (data) => dispatch => {
    data = data || {"orderId": -1,
    "status":"OK",
        "confirmationNumber":"UU12345",
        "chekinDate":"Jan 3027"
}
    dispatch({
        type: "RESET_PRICEANDTAX_INIT",
        payload: data
    })
}



/*

export const getBookError = (e) =>dispatch => {
    dispatch({
        type:typesBook.GET_BOOK_ERROR,
        error:e
    })
}
*/
export function loadReviewSingleNoPriceNow(rqValuesSpaceId){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow from Microservices DB swith sae key :' + rqValuesSpaceId)
    return dispatch => {
        dispatch(svFlyLoadReviewBegin())
        /*
        const url = 'http://localhost:8080/essearch/spaceLoadReview'
        const body = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }
          */
          const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spaceLoadReview`
          const body = {
              "query": {
                  "bool": {
                      "must": [
                          {
                              "match": {
                                  "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                              }
                          }
                      ]
                  }
              }
           }
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }

                if(r.data){

                   
                   
                    if(r.data.hits.hits.length>0){
                        const ar = r.data.hits.hits
                        let recs_with_duplicate_ar = []
                        let space_rec = {}
                       
                        var item , ob, sod, upperOb
                        
                        ar.forEach(a_rec => {
                            item = {}
                           
                            upperOb = a_rec['_source']
                            ob =lowercaseKeys(upperOb)
    
                            sod =  _.clone(ob)
    
                            
    
                            recs_with_duplicate_ar.push(sod)
                        });
                        space_rec = recs_with_duplicate_ar[0]
                        my_data_review_tp.booking = space_rec
                        let soj = space_rec
                        let svr_location = {
                            "flight_space_key": soj['flight_space_key'] ? soj['flight_space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                            "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                            "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                            "county": soj['county'] ? soj['county'] : "albanyt",
                            "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                            "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                            "country": soj['country_name'] ? soj['country_name'] : "usa",
                           "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                           "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                            
                           "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                           "state":soj['state'] ? soj['state'] : "NY"

                        }

                      let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                      my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                      let amenity_name = [
                        "300 feet elevator",
                        "air conditioning",
                        "private bathroom"
                    ]
                      my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name

                       
                    }
                    else {
                       console.log('getting error * review Load Action')
                       
                    }

                    const comData = {my_data_flyreview:my_data_review_tp}
                    

                   
                    dispatch(getFlyLoadReviewSuccess(comData))
                }
                else {
                    const comData = {my_data_flyreview:my_data_review_tp}
                    dispatch(getFlyLoadReviewSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
    }

}
/***ne cal start****/




export const flyLoadVpcData=(data)=>{
    console.log('action flyLoadVpcData')
    console.log(data)
    let my_data_dtoken = data

    if(my_data_dtoken.dtokenId && my_data_dtoken.dtokenId > 0){
        my_data_dtoken.id =  my_data_dtoken.dtokenId
    }else{
        my_data_dtoken.id = -12
    }

    if(my_data_dtoken.email && my_data_dtoken.email.length > 0){
        my_data_dtoken.email =  my_data_dtoken.email
    }else{
        my_data_dtoken.emai = "suelb22@yahoo.com"
    }
    
    let comData = {my_data_dtoken : my_data_dtoken}
    var action = {
       id:-1,
        type: 'FLYMYRESERVATIONS_D_TOKEN',
        payload:comData
    }
    console.log(action)
    return action

}

export const flyLoadCardData=(data)=>{
    console.log('action loadCardData')
    console.log(data)
    let my_data_card = data

    if(my_data_card.cardId && my_data_card.cardId > 0){
        my_data_card.id =  my_data_card.cardId
    }else{
        my_data_card.id = -12
    }

    if(my_data_card.cardNumber && my_data_card.cardNumber.length > 0){
        my_data_card.card =  my_data_card.cardNumber
    }else{
        my_data_card.cardNumber = "7777777777777777"
    }
    if(my_data_card.cardCvv && my_data_card.cardCvv.length > 0){
        my_data_card.cvv =  my_data_card.cardCvv
    }else{
        my_data_card.cvv = "777"
    }

    if(my_data_card.cardExpMonth && my_data_card.cardExpMonth.length > 0){
        my_data_card.mmexp =  my_data_card.cardExpMonth
    }else{
        my_data_card.mmexp = "07"
    }

    if(my_data_card.cardExpYear && my_data_card.cardExpYear.length > 0){
        my_data_card.yyyyexp =  my_data_card.cardExpYear
    }else{
        my_data_card.yyyyexp = "77"
    }


    let comData = {my_data_card : my_data_card}
    var action = {
       id:-1,
        type: 'FLYMYRESERVATIONS_PRIMARY_CARD',
        payload:comData
    }
    console.log(action)
    return action

}


export const flyLoadsvtpiData=(tpiData)=>{
    console.log('action loadCardData')
    console.log(tpiData)
    let init_tipData = {
        "id": "addLeft_step",
        "testlastName":"svlondon_raction_init",
    
        "dateOfBirth": "1982-01-15",
        
        "members": [
          {
            "documentType": "IDENTITY_CARD",
            "birthPlace": "Sanfrancisco",
            "issuanceLocation": "Sanfrancisco",
            "issuanceDate": "2015-04-13",
            "documentNumber": "00000069",
            "expiryDate": "2025-04-13",
            "issuanceCountry": "US",
            "validityCountry": "US",
            "nationality": "US",
            "holder": "Y"
          }
        ],
        "gender": "MALE"
       
      }
    if(!tpiData){

        tpiData = init_tipData
    }
   // console.log(data)
    //polulate from numTravellers
    /*
    let my_data_svtpi =[{
        "tid":1,
        "dateOfBirth": "1982-01-15",
        "gender": "MALE",
        "firstName": "Svbsv",
        "lastName": "Infinity",
        "emailAddress": "svr@yahoo.com",
        "memphones":[{       
            "deviceType": "MOBILE",
            "countryCallingCode": "34",
            "number": "480080085"
        }],
        "members": [
          {
            "documentType": "IDENTITY_CARD",
            "birthPlace": "Sanfrancisco",
            "issuanceLocation": "Sanfrancisco",
            "issuanceDate": "2015-04-13",
            "documentNumber": "00000069",
            "expiryDate": "2025-04-13",
            "issuanceCountry": "US",
            "validityCountry": "US",
            "nationality": "US",
            "holder": "Y"
          }
        ],
        id:'addLeft_STEP',
        gene:'addLeft_STEP',
        "clubName": "Soccer"
      
      
      }]

    let comData = {"my_data_svtpi" : my_data_svtpi}
    var action = {
       id:-1,
        type: 'FLYMYRESERVATIONS_PRIMARY_SVTPI',
        payload:comData
    }
    */
    var action = {
        id:-1,
         type: 'FLYMYRESERVATIONS_PRIMARY_SVTPI',
         payload:tpiData
     }
    console.log(action)
    return action

}
export const flyLoadsvtocData=(data)=>{
    console.log('action flyLoadsvtocData gets Hardcoded Data we need to make form number of travelers')
    console.log(data)
   // console.log(data)
    //polulate from numTravellers
    let my_data_svtoc ={
        "id": "addLeft_step",
        "testlastName": "svlondon",
        "dateOfBirth": "1982-01-15",
        "members": [
            {
                "tid": 1,
                "dateOfBirth": "1982-01-15",
                "gender": "MALE",
                "firstName": "Svbsv",
                "lastName": "Infinity",
                "emailAddress": "svr@yahoo.com",
                "memphones": [
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "34",
                        "number": "480080085"
                    }
                ],
                "members": [
                    {
                        "documentType": "IDENTITY_CARD",
                        "birthPlace": "Sanfrancisco",
                        "issuanceLocation": "Sanfrancisco",
                        "issuanceDate": "2015-04-13",
                        "documentNumber": "00000069",
                        "expiryDate": "2025-04-13",
                        "issuanceCountry": "US",
                        "validityCountry": "US",
                        "nationality": "US",
                        "holder": "Y"
                    }
                ],
                "id": "addLeft_STEP",
                "gene": "addLeft_STEP",
                "clubName": "Soccer"
            },
            {
                "tid": 2,
                "dateOfBirth": "1982-01-15",
                "gender": "MALE",
                "firstName": "Seteve",
                "lastName": "Borrow",
                "emailAddress": "steve@yahoo.com",
                "memphones": [
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "1",
                        "number": "480080081"
                    }
                ],
                "members": [
                    {
                        "documentType": "IDENTITY_CARD",
                        "birthPlace": "Sanfrancisco",
                        "issuanceLocation": "Sanfrancisco",
                        "issuanceDate": "2015-04-13",
                        "documentNumber": "00000069",
                        "expiryDate": "2025-04-13",
                        "issuanceCountry": "US",
                        "validityCountry": "US",
                        "nationality": "US",
                        "holder": "Y"
                    }
                ],
                "id": "addLeft_STEP1",
                "gene": "addLeft_STEP1",
                "clubName": "Soccer"
            }
        ],
           "gender": "MALE"
    }
    

    let comData = {"my_data_svtoc" : my_data_svtoc}
    var action = {
       id:-1,
        type: 'FLYMYRESERVATIONS_PRIMARY_SVTOC',
        payload:comData
    }
    console.log(action)
    return action

}

export const flyLoadsvdocData=(data)=>{
    console.log('action loadCardData')
   // console.log(data)
    //polulate from numTravellers
    let my_data_svdoc ={
        "tid":1,
        "dateOfBirth": "1982-01-15",
        "gender": "MALE",
        "firstName": "Svbsv",
        "lastName": "Infinity",
        "emailAddress": "svr@yahoo.com",
        "memphones":[{       
            "deviceType": "MOBILE",
            "countryCallingCode": "34",
            "number": "480080085"
        }],
        "members": [
          {
            "documentType": "IDENTITY_CARD",
            "birthPlace": "Sanfrancisco",
            "issuanceLocation": "Sanfrancisco",
            "issuanceDate": "2015-04-13",
            "documentNumber": "00000069",
            "expiryDate": "2025-04-13",
            "issuanceCountry": "US",
            "validityCountry": "US",
            "nationality": "US",
            "holder": "Y"
          }
        ],
        id:'addLeft_STEP',
        gene:'addLeft_STEP',
        "clubName": "Soccer"
      
      
      }

    let comData = {"my_data_svdoc" : my_data_svdoc}
    var action = {
       id:-1,
        type: 'FLYMYRESERVATIONS_PRIMARY_SVDOC',
        payload:comData
    }
    console.log(action)
    return action

}
/*loadReviewNowMyReservationForCustId  **/

export const flyLoadAddressData=(data)=>{
    console.log('action Oct7 load -Step0  flyLoadAddressData gets from FORM-FPD calls Oct6***********')
    console.log(data)
    let my_data_flyaddress = data
    if(my_data_flyaddress.zipcode && my_data_flyaddress.zipcode.length > 0){
        my_data_flyaddress.zip =  my_data_flyaddress.zipcode
    }else{
        my_data_flyaddress.zip = "77777"
    }

    if(my_data_flyaddress.addressId && my_data_flyaddress.addressId > 0){
        my_data_flyaddress.id =  my_data_flyaddress.addressId
    }else{
        my_data_flyaddress.id = -12
    }
    /*
    if(my_data_flyaddress.dateOfBirth && my_data_flyaddress.dateOfBirth.length > 0 ){
        my_data_flyaddress.dateOfBirth =  my_data_flyaddress.dateOfBirth
    }else{
        my_data_flyaddress.dateOfBirth = "1982-01-15"
    }*/

    if(my_data_flyaddress.gender && my_data_flyaddress.gender.length > 0){
        my_data_flyaddress.gender =  my_data_flyaddress.gender
    }else{
        my_data_flyaddress.gender = "MALE"
    }
   // my_data_flyaddress.gender  ="MALE"
   // my_data_flyaddress.dateOfBirth = "1982-01-15"

    let comData = {my_data_flyaddress : my_data_flyaddress}
    
    console.log('Oct5 Payment detail updating adressdate for form with data', comData)
   
    var action = {
       id:-1,
        type:'FLYMYRESERVATIONS_PRIMARY_ADDRESS',
        payload:comData
    }
    console.log(action)
    return action

}
 /*
    rq {"id":"19"}
 rs{
    "addressId": 19,
    "customerId": 7,
    "name": "Matti Bleak",
    "fname": "bleak",
    "lname": "Bleak",
    "phone": "5121231234",
    "email": "mb@yahoo.com",
    "login": "mb@yahoo.com",
    "password": null,
    "otherDetails": null,
    "city": "lincon",
    "state": "ca",
    "country": "usa",
    "address": null,
    "zipcode": "95012",
    "isdcode": "1",
    "addressType": null,
    "createdDate": null,
    "modifiedDate": null,
    "createdBy": null,
    "modifiedBy": null
}
    */
   /*
export const flyLoadAddressDataDB=(custProfile)=>{
    console.log('action CREATE_STEP')
   
    const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
    let nameQParam = -1
   
   

   
    
    const body = {
        "id": (custProfile && custProfile.addressId? custProfile.addressId:-1)
       }

       axios.post(url, body, {headers:headers})
       .then(
           r => {
            let comData = {my_data_flyaddress : null}
               if( r.data ){
                   const ob = r.data
                 

                   let my_data_flyaddress = ob
                    
                    comData.my_data_flyaddress = my_data_flyaddress
                   
                    console.log(action)
                   
                    dispatch(geLoadAddressDataDBCustSuccess(comData))
                   

               }
               else {
                   
                   dispatch(geLoadAddressDataDBCustSuccess(comData))
               }
           }
       ).catch(
        e=>dispatch(getLoadReviewError(e))
       )

    

}
*/

/*svnov27 start*/



export function flyLoadReviewNow(flyob){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc 1' )
   
    /*
    let flyob = {
        "svcookoffer_o": svcookoffer_o ? svcookoffer_o : null,
        "id":id
       }
    */
    let rqValuesSpaceId = flyob.id 
    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
   
    return dispatch => {
        dispatch(svFlyLoadReviewBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        //localhost:8000/amcosmosbika/hhsvfinalpricehhr
        const urlTokenOffer = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svgetTokenOffer`
        let bodyTokenOffer = {
            "docId": [
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXltZW50TWV0aG9kQ29kZSI6ImNhcmQiLCJuYW1lIjoiam9uYiIsImZuYW1lIjoiam9uIiwibG5hbWUiOiJiZXRhIiwicGhvbmUiOiI1MTIxMjM0MzIyIiwiZW1haWwiOiJqb25AeWFob28uY29tIiwiYWRkcmVzcyI6IjEyIGxpbnZvYyIsImxvZ2luIjoiam9uQHlhaG9vLmNvbSIsInBhc3N3b3JkIjoiUGV0ZTEyMyIsInBhc3N3b3JkbWlycm9yIjoiUGV0ZTEyMyIsImVuY3Bhc3N3b3JkIjoiUGV0ZTEyMyIsIm90aGVyRGV0YWlscyI6Ik5lZWQgcGlja3VwIiwiaXNkY29kZSI6IjEiLCJjdXN0b21lcklkIjo3LCJjcmVhdGVkQnkiOiJBYm9kZVN5c3RlbUFkbWluIiwibW9kaWZpZWRCeSI6IkFib2RlU3lzdGVtQWRtaW4iLCJjcmVhdGVkRGF0ZSI6IjIwMjQtMDctMTNUMDE6NDk6MzQuMDAwKzAwMDAiLCJtb2RpZmllZERhdGUiOiIyMDI0LTA3LTEzVDAxOjQ5OjM0LjAwMCswMDAwIiwiaWF0IjoxNzMzMTgzODg0LCJleHAiOjE3MzMxODc0ODR9.Io5nwoDqc92G-vEMHnMWBeyJ-f_T1yByatrqfnd1_5Q"
            ],
            "hsetname": "HotelInvDB"
        }
        //we do not get svtv we need tp pass sessionId from nodejs which paases tp react Session
        
        if(flyob.svtv && flyob.svtv.length > 2){
            let token =flyob.svtv
            let ar = []
            ar.push(token)
            bodyTokenOffer["docId"] = ar
             
        }
       
        
        axios.post(urlTokenOffer, bodyTokenOffer, {headers:headers})
        .then(
            r => { 
                /*svdec4 start*/
                console.log('svDec3 afterloafing svcook from db***** 1')
               
                let svdb_svcook =JSON.parse(r.data['svcook'])
                console.log('svDec3 afterloafing svcook from db***** 2')
                console.log(svdb_svcook)
               
                flyob['svcookoffer_o'] = svdb_svcook
                console.log('svDec3 afterloafing svcook from db***** flyob')
                console.log(flyob)
                 
        let url = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/rrsvfinalpricerrr`
        let urlBridge = null
        urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/rrsvfinalpricerrr`
        url = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : url
       

        const url_dj_hw = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/hhsvfinalpricehhr`
        const body_old = {
            "query": {
              "match": {
                "FLIGHTSPACEKEY.keyword": (rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
              }
            }
          }
        let body = {
            "offer":{
                "type": "flight-offer",
                "id": "1",
                "source": "GDS",
                "instantTicketingRequired": false,
                "nonHomogeneous": false,
                "oneWay": false,
                "isUpsellOffer": false,
                "lastTicketingDate": "2024-10-25",
                "lastTicketingDateTime": "2024-10-25",
                "numberOfBookableSeats": 3,
                "itineraries": [
                    {
                        "duration": "PT6H24M",
                        "segments": [
                            {
                                "departure": {
                                    "iataCode": "EWR",
                                    "terminal": "B",
                                    "at": "2024-11-01T19:29:00"
                                },
                                "arrival": {
                                    "iataCode": "SFO",
                                    "terminal": "1",
                                    "at": "2024-11-01T22:53:00"
                                },
                                "carrierCode": "AS",
                                "number": "295",
                                "aircraft": {
                                    "code": "73H"
                                },
                                "operating": {
                                    "carrierCode": "AS"
                                },
                                "duration": "PT6H24M",
                                "id": "1",
                                "numberOfStops": 0,
                                "blacklistedInEU": false
                            }
                        ]
                    }
                ],
                "price": {
                    "currency": "USD",
                    "total": "788.07",
                    "base": "719.07",
                    "fees": [
                        {
                            "amount": "0.00",
                            "type": "SUPPLIER"
                        },
                        {
                            "amount": "0.00",
                            "type": "TICKETING"
                        }
                    ],
                    "grandTotal": "788.07"
                },
                "pricingOptions": {
                    "fareType": [
                        "PUBLISHED"
                    ],
                    "includedCheckedBagsOnly": true
                },
                "validatingAirlineCodes": [
                    "AS"
                ],
                "travelerPricings": [
                    {
                        "travelerId": "1",
                        "fareOption": "STANDARD",
                        "travelerType": "ADULT",
                        "price": {
                            "currency": "USD",
                            "total": "788.07",
                            "base": "719.07"
                        },
                        "fareDetailsBySegment": [
                            {
                                "segmentId": "1",
                                "cabin": "BUSINESS",
                                "fareBasis": "VH7OAVFN",
                                "brandedFare": "FR",
                                "brandedFareLabel": "FIRST",
                                "class": "D",
                                "includedCheckedBags": {
                                    "quantity": 2
                                },
                                "amenities": [
                                    {
                                        "description": "SEAT ASSIGNMENT",
                                        "isChargeable": false,
                                        "amenityType": "PRE_RESERVED_SEAT",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "MEAL 1",
                                        "isChargeable": false,
                                        "amenityType": "MEAL",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "PRIORITY BOARDING",
                                        "isChargeable": false,
                                        "amenityType": "TRAVEL_SERVICES",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "110V AC POWER",
                                        "isChargeable": false,
                                        "amenityType": "ENTERTAINMENT",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "USB POWER",
                                        "isChargeable": false,
                                        "amenityType": "ENTERTAINMENT",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    },
                                    {
                                        "description": "CHANGEABLE TICKET",
                                        "isChargeable": false,
                                        "amenityType": "BRANDED_FARES",
                                        "amenityProvider": {
                                            "name": "BrandedFare"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
        const bodyPriceGet = {
            "query": {
              "match": {
                "FLIGHTSPACEKEY.keyword": "10000416@4@F@10@10@20251124@7@Y@SVR"
              }
            }
          }
       
        
          
        
        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojourPriceView`
       
        console.log('sv*****DEC3 oferr rq to get final prie START')
        console.log(flyob)

        console.log(flyob.svcookoffer_o)
        console.log('sv*****DEC3 oferr rq to get final prie END')

        body.offer = flyob.svcookoffer_o
        
                    const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
                    const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
                   
        axios.all([
            axios.post(url, body, {headers:headers}),
            axios.post(urlSpacePrice,bodyPriceGet, {headers:headers}),
            axios.post(urlGeoList, bodyGeoList, {headers:headers}),
        ], {
  timeout: 7000
})
        .then(

            axios.spread((r,r2,r5)=>{
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                       "airport_id": 30009,
                       "origin_airport_code": 1,
                       "origincity": "homer",
                       "origin_airport_city": "homer",
                       "origin_airport_country": "usa",
                       "origin_airport_timezone": "america/new_york",
                       "port_code_iata": 30009,
                       "airlines_db_id": 146,
                       "origin_airport_iata": "09a",
                       "dst_airport_code": "adq",
                       "airlines_vessel": "cr9",
                       "airlines_name_iata": "2o",
                       "airlines_code_iata": 4,
                       "flight_space_id": 13,
                       "flight_departure": "10:30",
                       "flight_departure_time": "10:30",
                       "flight_arrival": "04:30",
                       "flight_arrival_time": "04:30",
                       "flight_airline_num_stops": 1,
                       "flight_arrival_daytime": "pm",
                       "flight_departure_daytime": "am",
                       "startdate": "2023-11-24",
                       "enddate": "2026-12-01",
                       "airlines_name": "air salone",
                       "org_aiport_csc_addr": "homer,alaska,usa",
                       "flight_time_hhmm": "6hr 29min",
                       "flight_time": 209,
                       "flight_operated_by": "4009 operated by envoy airlines",
                       "flight_operator_owned": "y",
                       "origin_airport_state": "alaska",
                       "flight_departure_time_tzest": "2025-10-25t10:30:00-0400",
                       "flight_departure_date": "2025-10-25",
                       "flight_arrival_date": "2025-10-26",
                       "flight_arrival_time_tzest": "2025-10-26t16:30:00-0400",
                       "flight_space_key": "1@4@1@adq"
                   },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
               
                let price_tp = {
                    "currency": "USD",
                    "total": "788.07",
                    "base": "719.07",
                    "fees": [
                        {
                            "amount": "0.00",
                            "type": "SUPPLIER"
                        },
                        {
                            "amount": "0.00",
                            "type": "TICKETING"
                        },
                        {
                            "amount": "0.00",
                            "type": "FORM_OF_PAYMENT"
                        }
                    ],
                    "grandTotal": "788.07",
                    "billingCurrency": "USD"
                }
                let offer_tp = {
                    "type": "flight-offer",
                    "id": "1",
                    "source": "GDS",
                    "instantTicketingRequired": false,
                    "nonHomogeneous": false,
                    "paymentCardRequired": false,
                    "lastTicketingDate": "2024-10-25",
                    "itineraries": [
                        {
                            "segments": [
                                {
                                    "departure": {
                                        "iataCode": "EWR",
                                        "terminal": "B",
                                        "at": "2024-11-01T19:29:00"
                                    },
                                    "arrival": {
                                        "iataCode": "SFO",
                                        "terminal": "1",
                                        "at": "2024-11-01T22:53:00"
                                    },
                                    "carrierCode": "AS",
                                    "number": "295",
                                    "aircraft": {
                                        "code": "73H"
                                    },
                                    "operating": {
                                        "carrierCode": "AS"
                                    },
                                    "duration": "PT6H24M",
                                    "id": "1",
                                    "numberOfStops": 0,
                                    "co2Emissions": [
                                        {
                                            "weight": 612,
                                            "weightUnit": "KG",
                                            "cabin": "BUSINESS"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "price": {
                        "currency": "USD",
                        "total": "788.07",
                        "base": "719.07",
                        "fees": [
                            {
                                "amount": "0.00",
                                "type": "SUPPLIER"
                            },
                            {
                                "amount": "0.00",
                                "type": "TICKETING"
                            },
                            {
                                "amount": "0.00",
                                "type": "FORM_OF_PAYMENT"
                            }
                        ],
                        "grandTotal": "788.07",
                        "billingCurrency": "USD"
                    },
                    "pricingOptions": {
                        "fareType": [
                            "PUBLISHED"
                        ],
                        "includedCheckedBagsOnly": true
                    },
                    "validatingAirlineCodes": [
                        "AS"
                    ],
                    "travelerPricings": [
                        {
                            "travelerId": "1",
                            "fareOption": "STANDARD",
                            "travelerType": "ADULT",
                            "price": {
                                "currency": "USD",
                                "total": "788.07",
                                "base": "719.07",
                                "taxes": [
                                    {
                                        "amount": "5.00",
                                        "code": "ZP"
                                    },
                                    {
                                        "amount": "5.60",
                                        "code": "AY"
                                    },
                                    {
                                        "amount": "53.90",
                                        "code": "US"
                                    },
                                    {
                                        "amount": "4.50",
                                        "code": "XF"
                                    }
                                ],
                                "refundableTaxes": "5.60"
                            },
                            "fareDetailsBySegment": [
                                {
                                    "segmentId": "1",
                                    "cabin": "BUSINESS",
                                    "fareBasis": "VH7OAVFN",
                                    "brandedFare": "FR",
                                    "class": "D",
                                    "includedCheckedBags": {
                                        "quantity": 2
                                    }
                                }
                            ]
                        }
                    ]
                }
                let currencycode = '$'
                
                if(r.data && r.data.message){
                    console.log('spep10 error getting offer sjow error page')
             //let offerError = {error: true}
                    let svd = moment()
                    let ts =  "2026-08-23T02:27:18.038+0000"
                    if(svd){
                        ts =svd.format("dddd, MMMM Do YYYY, h:mm:ss a")
                    }

                    
                    let errorOb ={
                        "timestamp":ts,
                        "status": 500,
                        "error": "Offer Error",
                        "message": r.data.message ? r.data.message : "FloghtEnginer Error",
                        "path": "/kk/svflyReview"
                    }
                    dispatch(getOfferReviewError(errorOb))

                }else if(r.data && r.data.flightOffers){
                

                   

                   
                    if (r.data.flightOffers && r.data.flightOffers.length>0 && r.data.flightOffers[0].price ){
                        price_tp = r.data.flightOffers[0].price
                        offer_tp = r.data.flightOffers[0]
                        currencycode = price_tp.currency == "USD" ? "$": price_tp.currency

                    }else{
                        console.log('sv**weeorr LOADREVIEW ERROR')
                    }
                    let priceOb= {

                        "total": price_tp.grandTotal,
                        "base": price_tp.base,
                        "depositValue":"0",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": price_tp.currency || "USD",
                        "taxes": [
                            {
                                "amount": "5.00",
                                "code": "ZP"
                            },
                            {
                                "amount": "5.60",
                                "code": "AY"
                            },
                            {
                                "amount": "53.90",
                                "code": "US"
                            },
                            {
                                "amount": "4.50",
                                "code": "XF"
                            }
                        ],
                        "tax": {
                           
                            "taxTotal": currencycode+"00",
                            "maintax":   currencycode+"00",
                            "citytax":   currencycode+"00",
                
                            "taxPercent": "0",
                            "citytaxPercent": "0"
                        },
                        "fees": [
                            {
                                "amount": "0.00",
                                "type": "SUPPLIER"
                            },
                            {
                                "amount": "0.00",
                                "type": "TICKETING"
                            },
                            {
                                "amount": "0.00",
                                "type": "FORM_OF_PAYMENT"
                            }
                        ]
                    }
                    priceOb.fees = price_tp.fees
                    priceOb.taxes = price_tp.taxes
                    if(priceOb){
                        my_data_review_tp.price = priceOb
                    }
                    if(offer_tp){
                        my_data_review_tp.offer = offer_tp
                    }
                   
                    
                     
 
                     let comData = {my_data_flyreview:my_data_review_tp}
                     //svr5 start
                     let my_data_geo = null
                     console.log('svj25 my_data_geo*********')
                     console.log(r5.data )
                     if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                      my_data_geo = r5.data
                      comData.my_data_geo = my_data_geo
                     }
                     console.log(comData )
                     //svr5 end
                    
                     
                    
                    
                     dispatch(getFlyLoadReviewSuccess(comData))
                 }
                 else {
                     let comData = {my_data_flyreview:my_data_review_tp}
                     comData.my_data_geo =  {
                        "countryTypes": [
                            {
                                "name": "United STates America",
                                "a2": "US",
                                "a3": "USA",
                                "isonum": "840"
                            },
                           
                            {
                                "name": "Canada",
                                "isdcode": "01",
                                "a2": "CA",
                                "a3": "CAN",
                                "isonum": "124"
                            }
                        ],
                        "stateTypes": [
                            {
                                "name": "California",
                                "a2": "CA"
                            },
                            {
                                "name": "New York",
                                "a2": "NY"
                            },
                            {
                                "name": "Texas",
                                "a2": "TX"
                            }
                        ],
                        "isdcodeTypes": [
                            {
                                "name": "United States Of America(+1)",
                                "value": "+1"
                            }
                        ],
                        "genderTypes": [
                            {
                                "name": "CL_MALE",
                                "value": "MALE"
                            },
                            {
                                "name": "CL_FEMALE",
                                "value": "FEMALE"
                            }
                        ]
                    }
                     dispatch(getFlyLoadReviewSuccess(comData))
                 }

                   
                }
            )
            /*svend*/
          
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )

                 /*svdec4 end*/
	        }
        ).catch(
                
            e=>dispatch(getPriceAndTexError(e))
        )


       
    }

}

/*svj22 start*/
export function flypriceAndTexNowSecure(rqValues, svtv){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
    console.log(rqValues)
   
    if(rqValues && rqValues['traveller'] && rqValues['traveller']['dateOfBirth'] ){
        let dateOfBirth = rqValues['traveller']['dateOfBirth'] 
        if(dateOfBirth && _.isObject(dateOfBirth) && dateOfBirth._isAMomentObject === true ){
            let dob_date = dateOfBirth._d
            let dobmom =   moment(dob_date)
           
             let dobstr =    dobmom.format('YYYY-MM-DD')
             rqValues.traveller.dateOfBirth = dobstr

        }
        console.log(dateOfBirth)
        console.log(rqValues)
    }
    /*
     const { traveller}  = rqValues
    const  {dateOfBirth } = traveler
    if(dateOfBirth && _.isObject(dateOfBirth) && dateOfBirth._isAMomentObject === true ){
            let dobmom =  moment(dateOfBirth._isAMomentObject)
             let dobstr =    dobmom.format('YYYY-MM-DD')
             rqValues.traveller.dateOfBirth = dobstr

    }
    */
    console.log(svtv)
    return dispatch => {
        dispatch(svflypriceAndTexBegin())
        const urlNewCustomer = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/airPriceAndTaxReviewMultiEntity`
        //tmp fix nov 27
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/airPriceAndTaxReviewMultiEntityMYRESERVATIONSV`
        //const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/airPriceAndTaxReviewMultiEntityMYRESERVATIONSVSecure`
       
        let url  = urlMyReservation
        if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
            console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow LATEST**from Microservices DB with 8086 url :' + urlMyReservation)
    
            url = urlMyReservation

        }else{
            url = urlNewCustomer
        }

          const authtoken = `Bearer ${svtv}`
          const svheaders = { 'Authorization': authtoken,
          'Content-Type': 'application/json' };
       
        
        axios.post(url, rqValues, {headers:svheaders})
        .then(
            r => {
                let comData = {
                    "my_data_fly_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                /*sva */
                let crudsuccessob ={
                    "timestamp": "2015-08-23T02:27:18.038+0000",
                    "status": 200,
                    "error": "",
                    "message": "Create Done ",
                    "path": "/kk/svaddressDetailPost"
                }
                comData.crudsuccessob = crudsuccessob

                /*svae */
                if(r.data){
                   
                    const ob = r.data
                   
                    let productId = (ob.reservation.productId ? ob.reservation.productId : -2)
                    
                    /*svnob29 start*/
                    let url82 = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/createTravellersMulti`
      
                    let url82_cors_issue ='/amcos/createFullzz' 
                    //use when booking succeeds as tis will save in db. call dj from java restclient is robust and takes headers
                    let url82_svgood_working = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/saveAmcosReservationSecure`
                    //const urlNewCustomer = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/bbsvbookonebr`
                    let urlNewCustomer = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/mmsvbookmultimm`
                    let urlBridge = null
                    urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/mmsvbookmultimm`
                    urlNewCustomer = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : urlNewCustomer
           
                    
                    /*sva */
                    const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/airPriceAndTaxReviewMultiEntityMYRESERVATIONSVSecure`
                   /*
                    const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
                    rqValues = {"id":90}
                    */
                    /*svae*/
                    let url  = urlNewCustomer
                    if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
                      console.log('%%%%%%%%%%%%%%%sv++++REST API  Non19 For priceAndTexNow LATEST**from Microservices DB with 8086 url :' + urlMyReservation)
              
                      //url = urlMyReservation
                      //like localhost:8082/amcos/createFull
                      //amcos/createFullMulti
                     // url82 = 'http://localhost:8082/amcos/createFullMulti'
              
                  }
                    let t = null,contact_user_phone = null
                    if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
                        console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow LATEST**from Microservices DB with 8086 url :' + urlMyReservation)
                
                        //do nothingo ds reservation doesnot care wether new or old customer
              
                    }
                     /*svj22 start*/
                     let hasTime =   rqValues.TRAVELLER_DATE_HAS_TIME ? rqValues.TRAVELLER_DATE_HAS_TIME :"Y"
                     let s= "", m=""
                    /*svj22 end*/
                    let ui_rq = {
                        "offer": {
                            "type": "flight-offer",
                            "id": "1",
                            "source": "GDS",
                            "instantTicketingRequired": false,
                            "nonHomogeneous": false,
                            "paymentCardRequired": false,
                            "lastTicketingDate": "2024-10-25",
                            "itineraries": [
                                {
                                    "segments": [
                                        {
                                            "departure": {
                                                "iataCode": "EWR",
                                                "terminal": "B",
                                                "at": "2024-11-01T19:29:00"
                                            },
                                            "arrival": {
                                                "iataCode": "SFO",
                                                "terminal": "1",
                                                "at": "2024-11-01T22:53:00"
                                            },
                                            "carrierCode": "AS",
                                            "number": "295",
                                            "aircraft": {
                                                "code": "73H"
                                            },
                                            "operating": {
                                                "carrierCode": "AS"
                                            },
                                            "duration": "PT6H24M",
                                            "id": "1",
                                            "numberOfStops": 0,
                                            "co2Emissions": [
                                                {
                                                    "weight": 612,
                                                    "weightUnit": "KG",
                                                    "cabin": "BUSINESS"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "price": {
                                "currency": "USD",
                                "total": "788.07",
                                "base": "719.07",
                                "fees": [
                                    {
                                        "amount": "0.00",
                                        "type": "SUPPLIER"
                                    },
                                    {
                                        "amount": "0.00",
                                        "type": "TICKETING"
                                    },
                                    {
                                        "amount": "0.00",
                                        "type": "FORM_OF_PAYMENT"
                                    }
                                ],
                                "grandTotal": "788.07",
                                "billingCurrency": "USD"
                            },
                            "pricingOptions": {
                                "fareType": [
                                    "PUBLISHED"
                                ],
                                "includedCheckedBagsOnly": true
                            },
                            "validatingAirlineCodes": [
                                "AS"
                            ],
                            "travelerPricings": [
                                {
                                    "travelerId": "1",
                                    "fareOption": "STANDARD",
                                    "travelerType": "ADULT",
                                    "price": {
                                        "currency": "USD",
                                        "total": "788.07",
                                        "base": "719.07",
                                        "taxes": [
                                            {
                                                "amount": "5.00",
                                                "code": "ZP"
                                            },
                                            {
                                                "amount": "5.60",
                                                "code": "AY"
                                            },
                                            {
                                                "amount": "53.90",
                                                "code": "US"
                                            },
                                            {
                                                "amount": "4.50",
                                                "code": "XF"
                                            }
                                        ],
                                        "refundableTaxes": "5.60"
                                    },
                                    "fareDetailsBySegment": [
                                        {
                                            "segmentId": "1",
                                            "cabin": "BUSINESS",
                                            "fareBasis": "VH7OAVFN",
                                            "brandedFare": "FR",
                                            "class": "D",
                                            "includedCheckedBags": {
                                                "quantity": 2
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        "product": null,
                        "card": {
                            "id": "-1",
                            "card": "7777123412341234",
                            "cvv": "345",
                            "mmexp": "03",
                            "yyyyexp": "23",
                            "otherDetails": "SVMed facility",
                            "privateparking": "N",
                            "rentcar": "N",
                            "bookTaxi": "N",
                            "needFlight": "N",
                            "cardId": "-4",
                            "cardNumber": "7777777777777777",
                            "gene": "77771234--1234--1234"
                        },
                        "traveller": {
                            "id": "-1",
                            "gene": "1",
                            "fname": "alen",
                            "lname": "sim",
                            "email": "alen@sv.com",
                            "address": "12 lin",
                            "city": "san jose",
                            "state": "CA",
                            "zip": "95020",
                            "country": "usa",
                            "isdcode": "1",
                            "phone": "4081231234",
                            "bookingAgentType": "S",
                            "traveType": "P",
                            "specialRequests": "Wheel chair and Senior Citizen",
                            "card": "1234-1234--1234--1234",
                            "cvv": "Glen",
                            "mmexp": "04",
                            "yyyyexp": "2028",
                            "addressId": 36,
                            "customerId": 36,
                            "name": "alen beta",
                            "login": "alenb",
                            "password": null,
                            "otherDetails": "need pickup",
                            "zipcode": "99999",
                            "addressType": "B",
                            "createdDate": null,
                            "modifiedDate": null,
                            "createdBy": null,
                            "modifiedBy": null
                        },
                        "reservationAirProduct": {
                            "productCategoryCode": 5,
                            "productName": "AlaskaVacationKate57",
                            "productDetails": "AlaskaVacationKate57",
                            "description": "Alaska Kate57",
                            "producttype": "svr",
                            "flight_space_id": 13,
                            "flight_space_key": "1@4@1@adq",
                            "sale_ind": "Y",
                            "vernacularcode": "en",
                            "sojourncode": "RMC",
                            "startdate": "2023-11-24",
                            "enddate": "2026-12-01",
                            "commoditytype": "RMc",
                            "companycode": "SVR",
                            "week": 11,
                            "year": 24,
                            "exchange_value": 12,
                            "season": "RED",
                            "bkgrnd_srch_sw": "Y",
                            "pool": "NAMER",
                            "maxoccupancy": "2",
                            "flight_rack_rate": 23,
                            "webStatusFlag": "Y",
                            "srciata": "09a",
                            "dstiata": "adq",
                            "airlinesNameIata": "2o",
                            "airlinesCodeIata": 4,
                            "flightAirlineNumStops": 1,
                            "flightDepartureTimeTzest": "2025-10-25t10:30:00-0400",
                            "flightArrivalTimeTzest": "2025-10-26t16:30:00-0400",
                            "flightOperatedBy": "4009 operated by envoy airlines",
                            "flightOperatedOwned": "y",
                            "flightTimeHhmm": "6hr 29min",
                            "svCleanupColPending": "Y",
                            "flightid": 57,
                            "languagecode": "en",
                            "svrtypeid": "SVR"
                        },
                        "meta": {
                            "addressId": 36,
                            "customerId": 36,
                            "cardId": -1
                        }
                    }
                    let dob_body ={
                      "travelers": []
                  }
                    let body = {
                        "sv_offer": {
                            "type": "flight-offer",
                            "id": "1",
                            "source": "GDS",
                            "instantTicketingRequired": false,
                            "nonHomogeneous": false,
                            "oneWay": false,
                            "isUpsellOffer": false,
                            "lastTicketingDate": "2024-10-25",
                            "lastTicketingDateTime": "2024-10-25",
                            "numberOfBookableSeats": 7,
                            "itineraries": [
                                {
                                    "duration": "PT6H11M",
                                    "segments": [
                                        {
                                            "departure": {
                                                "iataCode": "EWR",
                                                "terminal": "B",
                                                "at": "2024-11-01T19:59:00"
                                            },
                                            "arrival": {
                                                "iataCode": "LAX",
                                                "terminal": "6",
                                                "at": "2024-11-01T23:10:00"
                                            },
                                            "carrierCode": "AS",
                                            "number": "287",
                                            "aircraft": {
                                                "code": "7M9"
                                            },
                                            "operating": {
                                                "carrierCode": "AS"
                                            },
                                            "duration": "PT6H11M",
                                            "id": "2",
                                            "numberOfStops": 0,
                                            "blacklistedInEU": false
                                        }
                                    ]
                                }
                            ],
                            "price": {
                                "currency": "USD",
                                "total": "728.06",
                                "base": "663.26",
                                "fees": [
                                    {
                                        "amount": "0.00",
                                        "type": "SUPPLIER"
                                    },
                                    {
                                        "amount": "0.00",
                                        "type": "TICKETING"
                                    }
                                ],
                                "grandTotal": "728.06"
                            },
                            "pricingOptions": {
                                "fareType": [
                                    "PUBLISHED"
                                ],
                                "includedCheckedBagsOnly": true
                            },
                            "validatingAirlineCodes": [
                                "AS"
                            ],
                            "travelerPricings": [
                                {
                                    "travelerId": "1",
                                    "fareOption": "STANDARD",
                                    "travelerType": "ADULT",
                                    "price": {
                                        "currency": "USD",
                                        "total": "728.06",
                                        "base": "663.26"
                                    },
                                    "fareDetailsBySegment": [
                                        {
                                            "segmentId": "2",
                                            "cabin": "BUSINESS",
                                            "fareBasis": "VH7TAUFN",
                                            "brandedFare": "FR",
                                            "brandedFareLabel": "FIRST",
                                            "class": "D",
                                            "includedCheckedBags": {
                                                "quantity": 2
                                            },
                                            "amenities": [
                                                {
                                                    "description": "SEAT ASSIGNMENT",
                                                    "isChargeable": false,
                                                    "amenityType": "PRE_RESERVED_SEAT",
                                                    "amenityProvider": {
                                                        "name": "BrandedFare"
                                                    }
                                                },
                                                {
                                                    "description": "MEAL 1",
                                                    "isChargeable": false,
                                                    "amenityType": "MEAL",
                                                    "amenityProvider": {
                                                        "name": "BrandedFare"
                                                    }
                                                },
                                                {
                                                    "description": "PRIORITY BOARDING",
                                                    "isChargeable": false,
                                                    "amenityType": "TRAVEL_SERVICES",
                                                    "amenityProvider": {
                                                        "name": "BrandedFare"
                                                    }
                                                },
                                                {
                                                    "description": "110V AC POWER",
                                                    "isChargeable": false,
                                                    "amenityType": "ENTERTAINMENT",
                                                    "amenityProvider": {
                                                        "name": "BrandedFare"
                                                    }
                                                },
                                                {
                                                    "description": "USB POWER",
                                                    "isChargeable": false,
                                                    "amenityType": "ENTERTAINMENT",
                                                    "amenityProvider": {
                                                        "name": "BrandedFare"
                                                    }
                                                },
                                                {
                                                    "description": "CHANGEABLE TICKET",
                                                    "isChargeable": false,
                                                    "amenityType": "BRANDED_FARES",
                                                    "amenityProvider": {
                                                        "name": "BrandedFare"
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        "sv_traveler_ar": [],
                        "sv_traveler": {
                            "id": "1",
                            "dateOfBirth": "1982-01-16",
                            "name": {
                                "firstName": "JORGE",
                                "lastName": "GONZALES"
                            },
                            "gender": "MALE",
                            "contact": {
                                "emailAddress": "jorge.gonzales833@telefonica.es",
                                "phones": [
                                    {
                                        "deviceType": "MOBILE",
                                        "countryCallingCode": "34",
                                        "number": "480080076"
                                    }
                                ]
                            },
                            "documents": [
                                {
                                    "documentType": "PASSPORT",
                                    "birthPlace": "Madrid",
                                    "issuanceLocation": "Madrid",
                                    "issuanceDate": "2015-04-14",
                                    "number": "00000000",
                                    "expiryDate": "2025-04-14",
                                    "issuanceCountry": "ES",
                                    "validityCountry": "ES",
                                    "nationality": "ES",
                                    "holder": true
                                }
                            ]
                        },
                        "sv_remark": {
                            "general": [
                                {
                                    "subType": "GENERAL_MISCELLANEOUS",
                                    "text": "ONLINE BOOKING FROM INCREIBLE VIAJES"
                                }
                            ]
                        },
                        "sv_ticketingAgreement": {
                            "option": "DELAY_TO_CANCEL",
                            "delay": "6D"
                        },
                        "sv_contact": {
                            "addresseeName": {
                                "firstName": "PABLO",
                                "lastName": "RODRIGUEZ"
                            },
                            "companyName": "INCREIBLE VIAJES",
                            "purpose": "STANDARD",
                            "phones": [
                                {
                                    "deviceType": "LANDLINE",
                                    "countryCallingCode": "34",
                                    "number": "480080071"
                                },
                                {
                                    "deviceType": "MOBILE",
                                    "countryCallingCode": "33",
                                    "number": "480080072"
                                }
                            ],
                            "emailAddress": "support@increibleviajes.es",
                            "address": {
                                "lines": [
                                    "Calle Prado, 16"
                                ],
                                "postalCode": "28014",
                                "cityName": "Madrid",
                                "countryCode": "ES"
                            }
                        }
                    }
                    //loder is boolean change in ingest add checkbok
                    let py_tp_ar = []
                    let py_tp = null
              
                    let db_tp_ar = []
                    let db_tp = null
              
                    let tmp_phone_ob = null;
                    //neeeded for gds vooking thisis profile
                   
                    let py_tp_traveler = {
                      "id": "1",
                      "dateOfBirth": "1982-01-16",
                      "name": {
                          "firstName": "JORGE",
                          "lastName": "GONZALES"
                      },
                      "gender": "MALE",
                      "contact": {
                          "emailAddress": "jorge.gonzales833@telefonica.es",
                          "phones": [
                              {
                                  "deviceType": "MOBILE",
                                  "countryCallingCode": "34",
                                  "number": "480080076"
                              }
                          ]
                      },
                      "documents": [
                          {
                              "documentType": "PASSPORT",
                              "birthPlace": "Madrid",
                              "issuanceLocation": "Madrid",
                              "issuanceDate": "2015-04-14",
                              "number": "00000000",
                              "expiryDate": "2025-04-14",
                              "issuanceCountry": "ES",
                              "validityCountry": "ES",
                              "nationality": "ES",
                              "holder": true
                          }
                      ]
                  }
                  if(rqValues.my_data_svtoc){
                     // let ta = rqValues.my_data_svtoc.members
                      //let td = rqValues.my_data_svtoc.memphones
                      let ta = []
                      let td = null
                      
                      body['my_data_svtoc'] = rqValues.my_data_svtoc
                      
                      if (_.isArray(rqValues.my_data_svtoc)){
                          ta = rqValues.my_data_svtoc
                          t = ta[0]
                          t.id = t.tid
                          delete t.gene
                          delete t.clubName
                          delete t.tid
                         
                      }
                       
                      
                      for(let i=0; i < ta.length; i++){
                          t = ta[i]
              
                         
                          py_tp = _.clone(py_tp_traveler)
                          py_tp["contact"] = {
                              "emailAddress": "",
                              "phones": [
                                 
                              ]
                          }
                          py_tp["name"] = {
                              "firstName": "",
                              "lastName": ""
                          }
                          if( t && t.memphones && _.isArray(t.memphones)){
                              td = t.memphones
                              py_tp["contact"][ "phones"] = t.memphones
                              if(i ===0){
                                  tmp_phone_ob =  t.memphones[0]
                                  if(!tmp_phone_ob["deviceType"]){
                                      tmp_phone_ob["deviceType"] ="MOBILE"
                                  }
                                 
                              }
                          }
                          py_tp[ "id"] = t["tid"]
                          py_tp[ "dateOfBirth"] = t["dateOfBirth"]
                          py_tp[ "gender"] = t["gender"]
                          
                          
                          py_tp["name"][ "firstName"] = t["firstName"]
                          py_tp["name"][ "lastName"] = t["lastName"]
                          
                          py_tp["contact"][ "emailAddress"] = t["emailAddress"]
              
                          
                          let mp =  (td && td[0])? td[0] : null
                          if(mp){
                              contact_user_phone = {}
                              //populate contact_user_phone
                              //"deviceType": "MOBILE",
                              contact_user_phone["deviceType"] ="MOBILE"
                              contact_user_phone["countryCallingCode"] =mp["countryCallingCode"]
                              contact_user_phone["number"] =mp["number"]
                          }
                          
                          let mda = t["members"]
                      
                          if(mda && (mda.length > 0)){
                          
                              py_tp["documents"] = mda
                              let doc = null;
                              for(let k=0; k < mda.length; k++){
                                  doc = mda[k]
                                  if(doc["holder"] == "Y"){
                                      doc["holder"] = true
              
                                  }else{
                                      doc["holder"] = true
                                  }
                              }
                          }
                          py_tp_ar.push(py_tp)
                     
              
                      }
                      /*svn22 start*/
                      for(let i=0; i < ta.length; i++){
                          t = ta[i]
              
                         
                          db_tp = _.clone(py_tp_traveler)
                          db_tp["contact"] = {
                              "emailAddress": "",
                              "phones": [
                                 
                              ]
                          }
                          db_tp["name"] = {
                              "firstName": "",
                              "lastName": ""
                          }
                          if( t && t.memphones && _.isArray(t.memphones)){
                              td = t.memphones
                              db_tp["contact"][ "phones"] = t.memphones
                              if(i ===0){
                                  tmp_phone_ob =  t.memphones[0]
                                  if(!tmp_phone_ob["deviceType"]){
                                      tmp_phone_ob["deviceType"] ="MOBILE"
                                  }
                                 
                              }
                          }
                          db_tp[ "id"] = t["tid"]
                          db_tp[ "dateOfBirth"] = t["dateOfBirth"]
                          db_tp[ "gender"] = t["gender"]
                          
                          
                          db_tp["name"][ "firstName"] = t["firstName"]
                          db_tp["name"][ "lastName"] = t["lastName"]
                          
                          db_tp["contact"][ "emailAddress"] = t["emailAddress"]
              
                          
                          let mp =  (td && td[0])? td[0] : null
                          if(mp){
                              contact_user_phone = {}
                              //populate contact_user_phone
                              //"deviceType": "MOBILE",
                              contact_user_phone["deviceType"] ="MOBILE"
                              contact_user_phone["countryCallingCode"] =mp["countryCallingCode"]
                              contact_user_phone["number"] =mp["number"]
                          }
                          
                          let mda = t["members"]
                          let db_documents = []
                          let db_doc = null;
                          if(mda && (mda.length > 0)){
                          
                              //db_tp["documents"] =  _.clone(mda) 
                              let doc = null;
                              console.log('***svj22**********mda')
                              console.log(mda)
                              for(let k=0; k < mda.length; k++){
                                  doc = mda[k]
                                  db_doc = _.clone(doc)
                                  if(db_doc["holder"] === true){
                                      db_doc["holder"] = "Y"
              
                                  }else{
                                      db_doc["holder"] = "N"
                                  }
                                   /*svdate svj22 start format */
                                  
                                   if(hasTime == "Y"){
                                  
                                    s=   db_doc["issuanceDate"]
                                      m =s.substring(0,10) 
                                    db_doc["issuanceDate"] = m
                                    s=   db_doc["expiryDate"]
                                      m =s.substring(0,10) 
                                    db_doc["expiryDate"] = m
                                   }
                                    /*svdate svj22 end */
                                  db_documents.push(db_doc)
              
                                  
                              }
                          }
                          db_tp["documents"] = db_documents
                          db_tp_ar.push(db_tp)
                     
              
                      }
                     
                      dob_body["travelers"] = db_tp_ar
                      /*svn22 end */
                      body["sv_traveler_ar"] = py_tp_ar
                      body["sv_traveler"] = py_tp_ar[0]
                     
                     
                  }else{
                   console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
                  }
                 
                    let ambt_tp = {
                
                        "dateOfBirth": "1982-01-15",
                        "gender": "MALE",
                        "documents": [
                            {
                                
                                "documentType": "IDENTITY_CARD",
                                "birthPlace": "Madrid",
                                "issuanceLocation": "Madrid",
                                "issuanceDate": "2015-04-13",
                                "documentNumber": "00000069",
                                "expiryDate": "2025-04-13",
                                "issuanceCountry": "ES",
                                "validityCountry": "ES",
                                "nationality": "ES",
                                "holder": "Y"
                               
                                
                            }
                        ],
                        "contact": {
                            "emailAddress": "svr@yahoo.com",
                            
                            "phones": [
                                {
                                    
                                    "deviceType": "MOBILE",
                                    "countryCallingCode": "34",
                                   
                                    
                                    "number": "480080085"
                                }
                            ]
                        },
                        "name": {
                            "firstName": "Svbsv",
                            "lastName": "Infinity"
                        }
                    }
                    if(rqValues.offer){
                        body.sv_offer = rqValues.offer
                    }else{
                     console.log('SVOCT28***ERROR********* SVWizard not sending offer***********')
                    }
                    let sv_contact_tp= {
                      "addresseeName": {
                          "firstName": "PABLO",
                          "lastName": "RODRIGUEZ"
                      },
                      "companyName": "INCREIBLE VIAJES",
                      "purpose": "STANDARD",
                      "phones": [
                          {
                              "deviceType": "LANDLINE",
                              "countryCallingCode": "34",
                              "number": "480080071"
                          },
                          {
                              "deviceType": "MOBILE",
                              "countryCallingCode": "33",
                              "number": "480080072"
                          }
                      ],
                      "emailAddress": "support@increibleviajes.es",
                      "address": {
                          "lines": [
                              "Calle Prado, 16"
                          ],
                          "postalCode": "28014",
                          "cityName": "Madrid",
                          "countryCode": "ES"
                      }
                  }
                    if(rqValues.traveller){
                        t = rqValues.traveller
                        ambt_tp["contact"][ "emailAddress"] = t["email"]
                        contact_user_phone =ambt_tp["contact"][ "phones"][0] 
                        contact_user_phone["countryCallingCode"] =t["isdcode"]
                        contact_user_phone["number"] =t["phone"]
              
                        ambt_tp[ "dateOfBirth"] = t["dateOfBirth"]
                        ambt_tp[ "gender"] = t["gender"]
                        ambt_tp["name"][ "firstName"] = t["fname"]
                        ambt_tp["name"][ "lastName"] = t["lname"]
                      
                        sv_contact_tp["addresseeName"]["firstName"] = t["fname"]
                        sv_contact_tp["addresseeName"]["lastName"] = t["lname"]
                        sv_contact_tp["purpose"]= "STANDARD"
                        sv_contact_tp["phones"]= new Array()
                        let profile_isd_2ltr = (t["isdcode"] &&  (t["isdcode"].length > 0 ) )? t["isdcode"] : "1" 
                        
                       
                        let svp_tp = {
                          "deviceType": "MOBILE",
                          "countryCallingCode": profile_isd_2ltr,
                          "number": t["phone"]
                      }
                      //teperay fix 
                       svp_tp = tmp_phone_ob
                       sv_contact_tp["phones"].push(svp_tp)
                       sv_contact_tp["emailAddress"]= t["email"]
              
                       sv_contact_tp["address"]["postalCode"] = t["zip"]
                       sv_contact_tp["address"]["cityName"] = t["city"]
                       sv_contact_tp["address"]["countryCode"] = "US"
                       let country = t["country"]
                       /*
                       if(country && country.length > 2){
                           //get country code from util fn before we come to actions
                           let country_code = "US"
                                sv_contact_tp["address"]["countryCode"] = t["country"]
                       }
                       */
              
                  
                       sv_contact_tp["address"]["lines"] = new Array()
                       let sva_addressline1 = t["address"]
                       sv_contact_tp["address"]["lines"].push(sva_addressline1)
                       body["sv_contact"] = sv_contact_tp
                       console.log("Nov11 sv_contact_tp")
                       console.log(sv_contact_tp)
                      
                       
                    }else{
                     console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
                     console.log("Nov11 ***ERROR*****NO sv_contact_tp")
                  }
                   
                   
                      const authtoken = `Bearer ${svtv}`
                      const svheaders = { 'Authorization': authtoken,
                      'Content-Type': 'application/json' };
                     
                     let body_amcos_tp = {
                  
                          "dateOfBirth": "1982-01-15",
                          "gender": "MALE",
                          "documents": [
                              {
                                  
                                  "documentType": "IDENTITY_CARD",
                                  "birthPlace": "Madrid",
                                  "issuanceLocation": "Madrid",
                                  "issuanceDate": "2015-04-13",
                                  "documentNumber": "00000069",
                                  "expiryDate": "2025-04-13",
                                  "issuanceCountry": "ES",
                                  "validityCountry": "ES",
                                  "nationality": "ES",
                                  "holder": "Y"
                                 
                                  
                              }
                          ],
                          "contact": {
                              "emailAddress": "svr@yahoo.com",
                              
                              "phones": [
                                  {
                                      
                                      "deviceType": "MOBILE",
                                      "countryCallingCode": "34",
                                     
                                      
                                      "number": "480080085"
                                  }
                              ]
                          },
                          "name": {
                              "firstName": "Svbsv",
                              "lastName": "Infinity"
                          }
                      }
                      let body_amcos = body_amcos_tp
                      if(rqValues.traveller){
                          t = rqValues.traveller
                          body_amcos["contact"][ "emailAddress"] = t["email"]
                          contact_user_phone =body_amcos["contact"][ "phones"][0] 
                          if(t["isdcode"] && t["isdcode"].length > 2){
                              contact_user_phone["countryCallingCode"] =t["isdcode"]
                          }else{
                              contact_user_phone["countryCallingCode"] ="1"
                          }
                          
                          contact_user_phone["number"] =t["phone"]
                
                          body_amcos[ "dateOfBirth"] = t["dateOfBirth"]
                          body_amcos[ "gender"] = t["gender"]
                          body_amcos["name"][ "firstName"] = t["fname"]
                          body_amcos["name"][ "lastName"] = t["lname"]
                
                         
                      }else{
                       console.log('SVOCT28***ERROR********* SVWizard not sending TRAVELLER***********')
                      }
                      const urlSaveItn82 = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svItnsSaveReservation`
       
                     // let urlSaveItn82 = 'localhost:8086/essearch/svItnsSaveReservation'
                      let body_svSaveReservation = {
                        "productId":61,
                        "itineraries": [
                            {
                                "segments": [
                                    {
                                        "departure": {
                                            "iataCode": "LAX",
                                            "terminal": "B",
                                            "at": "2024-11-01T19:29:00"
                                        },
                                        "arrival": {
                                            "iataCode": "JFK",
                                            "terminal": "1",
                                            "at": "2024-11-01T22:53:00"
                                        },
                                        "carrierCode": "AS",
                                        "number": "295",
                                        "aircraft": {
                                            "code": "73H"
                                        },
                                        "operating": {
                                            "carrierCode": "AS"
                                        },
                                        "duration": "PT6H24M",
                                        "id": "1",
                                        "numberOfStops": 0,
                                        "co2Emissions": [
                                            {
                                                "weight": 612,
                                                "weightUnit": "KG",
                                                "cabin": "BUSINESS"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                    body_svSaveReservation["productId"] = productId
                    body_svSaveReservation[ "itineraries"] = body.sv_offer.itineraries
                    
                      
                      axios.all([
              
                          axios.post(url, body, {headers:headers}),
                          axios.post(url82, dob_body,{headers:headers}),
                          axios.post(urlSaveItn82, body_svSaveReservation,{headers:headers})
                      ])
                      .then(
                          axios.spread((r,r2)=>{
              
                              let comData = {
                                  "my_data_fly_price_confirmation" : {
              
                                      "status":"OK",
                                      "confirmationNumber":"UU12345",
                                      "chekinDate":"Jan 3027"
                                  }
                              }
                              /*sva */
                              let crudsuccessob ={
                                  "timestamp": "2015-08-23T02:27:18.038+0000",
                                  "status": 200,
                                  "error": "",
                                  "message": "Create Done ",
                                  "path": "/kk/svaddressDetailPost"
                              }
                              comData.crudsuccessob = crudsuccessob
                              if(r2.data){
                                  console.log('Nov2 **82 save reservation')
                                  console.log(r2.data)
                              }
                              /*svae */
                              if(r.data && _.isArray(r.data)){
                                 
                                  const ob_ar = r.data
                                 
                                  const ob = ob_ar[0]
                                  const {associatedRecords} = ob
                                  if(!ob.reference ){
                                      let eeb = {
              
                                      }
                                      eeb.errob = ob
                                      dispatch(getPriceAndTexError(eeb))
                                  }else{
                                      comData.my_data_fly_price_confirmation.confirmationNumber =associatedRecords[0].reference
              
                                      comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_fly_price_confirmation.confirmationNumber
                                  
              
                                 
                                      dispatch(getPriceAndTexSuccess(comData))
                           
                                  }
                                 
                                        }
                              else {
                                comData.my_data_fly_price_confirmation.status = "FAILED"
                                comData.my_data_fly_price_confirmation.confirmationNumber = "XXX"
                                comData.my_data_fly_price_confirmation.chekinDate = "Jan 3027"
                                  
                                  if(_.isObject(r.data) &&  _.isString(r.data.message)	){
                                    comData.my_data_fly_price_confirmation.confirmationNumber =r.data.message
                                   
                                  }

                                 
              
                                  dispatch(getPriceAndTexError(comData))
                              }
                          })
                      ).catch(
                          e=>dispatch(getPriceAndTexError(e))
                             
                      )
                   
                    /*svov29 end */
                   
                          
                    }else {
                    comData.my_data_fly_price_confirmation.status = "FAILED"
                    comData.my_data_fly_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_fly_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexError(comData))
                }
            }
        ).catch(
            
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}

/*svj22 end*/

/*svj23 start*/
export const flySaveTocumentReviewSuccess = (dataOb) => dispatch => {
    //we have mo object lets fix that
    //my_data_svtoc
     /*svj22 start*/
     console.log('**svj23*************(((((((((SVSVSVSVSVS**********start')
     
     let hasTime =   dataOb.TRAVELLER_DATE_HAS_TIME ? dataOb.TRAVELLER_DATE_HAS_TIME :"Y"
     let s= "", m=""
     console.log('hasTime',hasTime)
    /*svj22 end*/
    let rootDoc = dataOb.my_data_svtoc
    //let ta_one = rootDoc.members
    let t = null
    let ta = rootDoc.members
    let doc = null
    let mofval = null
    let mofval_str = null
    let vob_date  = null
    let vob = null
    let vob_is_date = false
    //let hasTime = "Y"
    //ta.push(ta_one)
    console.log(ta)
     /*svn22 start*/
     for(let i=0; i < ta.length; i++){
        t = ta[i]
       
        if(hasTime == "Y"){
                
            vob=    t['dateOfBirth']
            if(_.isString(vob) ){
              s =  t['dateOfBirth']
              m =s.substring(0,10) 
              t["dateOfBirth"] = m
            }else{
              vob_date = vob._d
              console.log(vob_date)
              mofval = moment(vob_date)
              mofval_str = mofval.format('YYYY-MM-DD')
              s = mofval_str
              m =s.substring(0,10) 
             
              t["dateOfBirth"] = m
              
            }
        }
       
       
        
        let mda = t["members"]
       
        if(mda && (mda.length > 0)){
        
            //db_tp["documents"] =  _.clone(mda) 
           
           
            console.log('***svj23**********mda')
            console.log(mda)
            for(let k=0; k < mda.length; k++){
                doc = mda[k]
                
                 /*svdate svj23 start format */
                
                 if(hasTime == "Y"){
                
                  vob=   doc["issuanceDate"]
                  if(_.isString(vob) ){
                    s =  doc["issuanceDate"]
                    m =s.substring(0,10) 
                    doc["issuanceDate"] = m
                  }else{
                    vob_date = vob._d
                    console.log(vob_date)
                    mofval = moment(vob_date)
                    mofval_str = mofval.format('YYYY-MM-DD')
                    s = mofval_str
                    m = s
                    doc["issuanceDate"] = m
                    
                  }
                  vob=   doc["expiryDate"]
                  if(_.isString(vob) ){
                    s =  doc["issuanceDate"]
                    m =s.substring(0,10) 
                    doc["expiryDate"] = m
                  }else{
                    vob_date = vob._d
                    vob_is_date = _.isDate(vob)
                   
                    console.log(vob_date)
                    mofval = moment(vob_date)
                    mofval_str = mofval.format('YYYY-MM-DD')
                    s = mofval_str
                    m = s
                    doc["expiryDate"] = m
                    
                  }
                  
        

                   
                 }
                  /*svdate svj23 end */
                
                
            }
        }
      

    }
   
   
    console.log(ta)
   // dataOb = ta[0]
    console.log(dataOb)
    console.log('**svj23*************(((((((((SVSVSVSVSVS**********end')
    /*svn22 end */

    dispatch({
        type: 'SAVETOCUMENT_FLYREVIEW_SUCCESS',
        payload: dataOb
    })
}
/*svj23 end*/

/*svf4 start*/
export function flyLoadReviewNowMyReservationForCustId(flyob, custProfile){
    let rqValuesSpaceId = flyob.id 
    console.log('%%%%%%%%%%%%%%%sv++++REST API  Nov19review For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
    return dispatch => {
        dispatch(svFlyLoadReviewBegin())
        //const url = 'http://localhost:8086/essearch/svgetTokenOffer'
        const urlTokenOffer = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svgetTokenOffer`
        let bodyTokenOffer = {
            "docId": [
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXltZW50TWV0aG9kQ29kZSI6ImNhcmQiLCJuYW1lIjoiam9uYiIsImZuYW1lIjoiam9uIiwibG5hbWUiOiJiZXRhIiwicGhvbmUiOiI1MTIxMjM0MzIyIiwiZW1haWwiOiJqb25AeWFob28uY29tIiwiYWRkcmVzcyI6IjEyIGxpbnZvYyIsImxvZ2luIjoiam9uQHlhaG9vLmNvbSIsInBhc3N3b3JkIjoiUGV0ZTEyMyIsInBhc3N3b3JkbWlycm9yIjoiUGV0ZTEyMyIsImVuY3Bhc3N3b3JkIjoiUGV0ZTEyMyIsIm90aGVyRGV0YWlscyI6Ik5lZWQgcGlja3VwIiwiaXNkY29kZSI6IjEiLCJjdXN0b21lcklkIjo3LCJjcmVhdGVkQnkiOiJBYm9kZVN5c3RlbUFkbWluIiwibW9kaWZpZWRCeSI6IkFib2RlU3lzdGVtQWRtaW4iLCJjcmVhdGVkRGF0ZSI6IjIwMjQtMDctMTNUMDE6NDk6MzQuMDAwKzAwMDAiLCJtb2RpZmllZERhdGUiOiIyMDI0LTA3LTEzVDAxOjQ5OjM0LjAwMCswMDAwIiwiaWF0IjoxNzMzMTgzODg0LCJleHAiOjE3MzMxODc0ODR9.Io5nwoDqc92G-vEMHnMWBeyJ-f_T1yByatrqfnd1_5Q"
            ],
            "hsetname": "HotelInvDB"
        }
        
        if(flyob.svtv && flyob.svtv.length > 2){
            let token =flyob.svtv
            let ar = []
            ar.push(token)
            bodyTokenOffer["docId"] = ar
             
        }
       
        axios.post(urlTokenOffer, bodyTokenOffer, {headers:headers})
        .then(
            r => { 
                /*svdec4 start*/
                console.log('svDec3 afterloafing svcook from db***** 1')
               
                let svdb_svcook =JSON.parse(r.data['svcook'])
                console.log('svDec3 afterloafing svcook from db***** 2')
                console.log(svdb_svcook)
               
                flyob['svcookoffer_o'] = svdb_svcook
                console.log('svDec3 afterloafing svcook from db***** flyob')
                console.log(flyob)
                let url = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/rrsvfinalpricerrr`
                let urlBridge = null
                urlBridge = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/amcosmosbika/rrsvfinalpricerrr`
                url = SV_SOJ_SVDJMOCK_BRIDGE === "SVINGEST" ? urlBridge : url

                const url_dj_hw = `${SV_SOJ_SVDJMOCK_ADDRESS}/amcosmosbika/hhsvfinalpricehhr`
                let dob_body ={
                    "travelers": []
                }
                let body = {
                    "offer":{
                        "type": "flight-offer",
                        "id": "1",
                        "source": "GDS",
                        "instantTicketingRequired": false,
                        "nonHomogeneous": false,
                        "oneWay": false,
                        "isUpsellOffer": false,
                        "lastTicketingDate": "2024-10-25",
                        "lastTicketingDateTime": "2024-10-25",
                        "numberOfBookableSeats": 3,
                        "itineraries": [
                            {
                                "duration": "PT6H24M",
                                "segments": [
                                    {
                                        "departure": {
                                            "iataCode": "EWR",
                                            "terminal": "B",
                                            "at": "2024-11-01T19:29:00"
                                        },
                                        "arrival": {
                                            "iataCode": "SFO",
                                            "terminal": "1",
                                            "at": "2024-11-01T22:53:00"
                                        },
                                        "carrierCode": "AS",
                                        "number": "295",
                                        "aircraft": {
                                            "code": "73H"
                                        },
                                        "operating": {
                                            "carrierCode": "AS"
                                        },
                                        "duration": "PT6H24M",
                                        "id": "1",
                                        "numberOfStops": 0,
                                        "blacklistedInEU": false
                                    }
                                ]
                            }
                        ],
                        "price": {
                            "currency": "USD",
                            "total": "788.07",
                            "base": "719.07",
                            "fees": [
                                {
                                    "amount": "0.00",
                                    "type": "SUPPLIER"
                                },
                                {
                                    "amount": "0.00",
                                    "type": "TICKETING"
                                }
                            ],
                            "grandTotal": "788.07"
                        },
                        "pricingOptions": {
                            "fareType": [
                                "PUBLISHED"
                            ],
                            "includedCheckedBagsOnly": true
                        },
                        "validatingAirlineCodes": [
                            "AS"
                        ],
                        "travelerPricings": [
                            {
                                "travelerId": "1",
                                "fareOption": "STANDARD",
                                "travelerType": "ADULT",
                                "price": {
                                    "currency": "USD",
                                    "total": "788.07",
                                    "base": "719.07"
                                },
                                "fareDetailsBySegment": [
                                    {
                                        "segmentId": "1",
                                        "cabin": "BUSINESS",
                                        "fareBasis": "VH7OAVFN",
                                        "brandedFare": "FR",
                                        "brandedFareLabel": "FIRST",
                                        "class": "D",
                                        "includedCheckedBags": {
                                            "quantity": 2
                                        },
                                        "amenities": [
                                            {
                                                "description": "SEAT ASSIGNMENT",
                                                "isChargeable": false,
                                                "amenityType": "PRE_RESERVED_SEAT",
                                                "amenityProvider": {
                                                    "name": "BrandedFare"
                                                }
                                            },
                                            {
                                                "description": "MEAL 1",
                                                "isChargeable": false,
                                                "amenityType": "MEAL",
                                                "amenityProvider": {
                                                    "name": "BrandedFare"
                                                }
                                            },
                                            {
                                                "description": "PRIORITY BOARDING",
                                                "isChargeable": false,
                                                "amenityType": "TRAVEL_SERVICES",
                                                "amenityProvider": {
                                                    "name": "BrandedFare"
                                                }
                                            },
                                            {
                                                "description": "110V AC POWER",
                                                "isChargeable": false,
                                                "amenityType": "ENTERTAINMENT",
                                                "amenityProvider": {
                                                    "name": "BrandedFare"
                                                }
                                            },
                                            {
                                                "description": "USB POWER",
                                                "isChargeable": false,
                                                "amenityType": "ENTERTAINMENT",
                                                "amenityProvider": {
                                                    "name": "BrandedFare"
                                                }
                                            },
                                            {
                                                "description": "CHANGEABLE TICKET",
                                                "isChargeable": false,
                                                "amenityType": "BRANDED_FARES",
                                                "amenityProvider": {
                                                    "name": "BrandedFare"
                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                }
                body.offer = flyob.svcookoffer_o
                /*
                const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/flyLoadReview`
                const body = {
                    "query": {
                      "match": {
                        "FLIGHTSPACEKEY.keyword": (rqValuesSpaceId? rqValuesSpaceId:"1@4@1@ADQ") 
                      }
                    }
                  }
                */
        
                const bodyBad = {
                    "query": {
                        "bool": {
                            "must": [
                                {
                                    "match": {
                                        "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                                    }
                                }
                            ]
                        }
                    }
                 }
        
                
                  
                
                const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojourPriceView`
                const bodyPriceGet = {
                    "query": {
                      "match": {
                        "SPACEKEY.keyword": "10000416@4@F@10@10@20251124@7@Y@SVR"
                      }
                    }
                  }
        //localhost:8086/account/addressListByCustomerIdView
                const urlAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListByCustomerIdView`
                const bodyAddressList = {
                    "docId": [
                        
                    ],
                    "hsetname": "HotelInvDB"
                }
               
                const urlCardList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/cardListByCustomerIdView`
                const bodyCardList = {
                    "docId": [
                        
                    ],
                    "hsetname": "HotelInvDB"
                }
                const bodyGeoNewList = {
                    "docId": [
                        
                    ],
                    "hsetname": "HotelInvDB"
                }
                if(custProfile && (custProfile.customerId > 0)){
                    let customerId = custProfile.customerId
                    bodyAddressList.docId.push("" + customerId)
                    bodyCardList.docId.push("" + customerId)
                    bodyGeoNewList.docId.push("" + customerId)
                }else{
                    console.log('Nov19review custProfile + error by UI')
                }
                /*svj21 start*/
               // const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geographyMyReservation`
               const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
               
                const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
               
        
                axios.all([
                    axios.post(url, body, {headers:headers}),
                    axios.post(urlSpacePrice,bodyPriceGet, {headers:headers}),
                    axios.post(urlAddressList, bodyAddressList, {headers:headers}),
                    axios.post(urlCardList, bodyCardList, {headers:headers}),
                  
                    /*svj9 start*/
                      axios.post(urlGeoList, bodyGeoNewList, {headers:headers}),
                    //axios.post(urlGeoList, bodyGeoList, {headers:headers}),
                    /*svj9 end*/
                    

                ], {
          timeout: 7000
        })
                .then(
                    axios.spread((r,r2, r3,r4,r5)=>{
        
                        console.log('********SVF3  START afterloafing svcook from db***** rsr r2 r3 r4 r5 3')
                       
                        console.log(r)
                        console.log(r2)
                        console.log(r3)
                        console.log(r4)
                        console.log(r5)
                        console.log('********SVF3  ENDafterloafing svcook from db***** rsr r2 r3 r4 r5 3')
   
                        let  my_data_review_tp = {
                            "Request": {
                                "checkin": "OK",
                                "stay": "6",
                                "stayInit": "nights",
                                "checkout": "UU12345",
                                "checkinTime": "Sat, Sept 9, 3027",
                                "checkinTimePrefix": "From 3:00 PM",
                                "checkoutTimePrefix": "Until 11:00 AM",
                                "checkoutTime": "Sat, Sept 16, 3027"
                            },
                            "spaceDet": {
                            
                                "space_details": "Queen Room with Two Queen Beds",
                                "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                                "cancellation": "Free cancellation before December 9, 2024 ",
                                "guests": "2 adults ",
                                "cleaniness_score" : "7.7",
                                "non_smoking":true,
                        
                                "space_amenity_name": [
                                    "300 feet elevator",
                                    "air conditioning",
                                    "private bathroom"
                                ]
                               
                               
                            },
                            "booking": {
                               "airport_id": 30009,
                               "origin_airport_code": 1,
                               "origincity": "homer",
                               "origin_airport_city": "homer",
                               "origin_airport_country": "usa",
                               "origin_airport_timezone": "america/new_york",
                               "port_code_iata": 30009,
                               "airlines_db_id": 146,
                               "origin_airport_iata": "09a",
                               "dst_airport_code": "adq",
                               "airlines_vessel": "cr9",
                               "airlines_name_iata": "2o",
                               "airlines_code_iata": 4,
                               "flight_space_id": 13,
                               "flight_departure": "10:30",
                               "flight_departure_time": "10:30",
                               "flight_arrival": "04:30",
                               "flight_arrival_time": "04:30",
                               "flight_airline_num_stops": 1,
                               "flight_arrival_daytime": "pm",
                               "flight_departure_daytime": "am",
                               "startdate": "2023-11-24",
                               "enddate": "2026-12-01",
                               "airlines_name": "air salone",
                               "org_aiport_csc_addr": "homer,alaska,usa",
                               "flight_time_hhmm": "6hr 29min",
                               "flight_time": 209,
                               "flight_operated_by": "4009 operated by envoy airlines",
                               "flight_operator_owned": "y",
                               "origin_airport_state": "alaska",
                               "flight_departure_time_tzest": "2025-10-25t10:30:00-0400",
                               "flight_departure_date": "2025-10-25",
                               "flight_arrival_date": "2025-10-26",
                               "flight_arrival_time_tzest": "2025-10-26t16:30:00-0400",
                               "flight_space_key": "1@4@1@adq"
                           },
                            "price": {
                                "total": "$923",
                                "depositValue":"$200.26",
                                "depositName":"Damage Deposit (Fully refundable)",
                                "currency": "usd",
                                "tax": {
                                   
                                    "taxTotal": "$102.34",
                                    "maintax": "$49.08",
                                    "citytax": "$53.26",
                        
                                    "taxPercent": "6",
                                    "citytaxPercent": "6.5"
                                }
                            },
                            "id": "addLeft_step",
                            "gene": "addLeft_step",
                            "dcountry": "China",
                            "privateparking":false,
                            "rentcar":false,
                            "bookTaxi":false,
                            "needFlight":false,
                            "arrivalTimeZone":"tz_pst",
                            "fname": "John",
                            "lname": "Glen",
                            "email": "john123@yahoo.com",
                            "address": "Glen",
                            "city": "Glen",
                            "state": "Glen",
                            "zip": "12110",
                            "dateOfBirth":"1982-01-16",
                            "gender":"MALE",
                            "country": "Glen",
                            "isdcode": "+1",
                            "phone": "Glen",
                            "bookingAgentType": "self",
                            "traveType": "Personal",
                            "specialRequests": "Wheel chair and Senior Citizen",
                            "gname": "Glen",
                            "gemail": "Glen@yahoo.com",
                            "card": "1234-1234--1234--1234",
                            "cvv": "Glen",
                            "mmexp": "04",
                            "yyyyexp": "2028"
                        }
                       
                        let price_tp = {
                            "currency": "USD",
                            "total": "788.07",
                            "base": "719.07",
                            "fees": [
                                {
                                    "amount": "0.00",
                                    "type": "SUPPLIER"
                                },
                                {
                                    "amount": "0.00",
                                    "type": "TICKETING"
                                },
                                {
                                    "amount": "0.00",
                                    "type": "FORM_OF_PAYMENT"
                                }
                            ],
                            "grandTotal": "788.07",
                            "billingCurrency": "USD"
                        }
                        let offer_tp = {
                            "type": "flight-offer",
                            "id": "1",
                            "source": "GDS",
                            "instantTicketingRequired": false,
                            "nonHomogeneous": false,
                            "paymentCardRequired": false,
                            "lastTicketingDate": "2024-10-25",
                            "itineraries": [
                                {
                                    "segments": [
                                        {
                                            "departure": {
                                                "iataCode": "EWR",
                                                "terminal": "B",
                                                "at": "2024-11-01T19:29:00"
                                            },
                                            "arrival": {
                                                "iataCode": "SFO",
                                                "terminal": "1",
                                                "at": "2024-11-01T22:53:00"
                                            },
                                            "carrierCode": "AS",
                                            "number": "295",
                                            "aircraft": {
                                                "code": "73H"
                                            },
                                            "operating": {
                                                "carrierCode": "AS"
                                            },
                                            "duration": "PT6H24M",
                                            "id": "1",
                                            "numberOfStops": 0,
                                            "co2Emissions": [
                                                {
                                                    "weight": 612,
                                                    "weightUnit": "KG",
                                                    "cabin": "BUSINESS"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "price": {
                                "currency": "USD",
                                "total": "788.07",
                                "base": "719.07",
                                "fees": [
                                    {
                                        "amount": "0.00",
                                        "type": "SUPPLIER"
                                    },
                                    {
                                        "amount": "0.00",
                                        "type": "TICKETING"
                                    },
                                    {
                                        "amount": "0.00",
                                        "type": "FORM_OF_PAYMENT"
                                    }
                                ],
                                "grandTotal": "788.07",
                                "billingCurrency": "USD"
                            },
                            "pricingOptions": {
                                "fareType": [
                                    "PUBLISHED"
                                ],
                                "includedCheckedBagsOnly": true
                            },
                            "validatingAirlineCodes": [
                                "AS"
                            ],
                            "travelerPricings": [
                                {
                                    "travelerId": "1",
                                    "fareOption": "STANDARD",
                                    "travelerType": "ADULT",
                                    "price": {
                                        "currency": "USD",
                                        "total": "788.07",
                                        "base": "719.07",
                                        "taxes": [
                                            {
                                                "amount": "5.00",
                                                "code": "ZP"
                                            },
                                            {
                                                "amount": "5.60",
                                                "code": "AY"
                                            },
                                            {
                                                "amount": "53.90",
                                                "code": "US"
                                            },
                                            {
                                                "amount": "4.50",
                                                "code": "XF"
                                            }
                                        ],
                                        "refundableTaxes": "5.60"
                                    },
                                    "fareDetailsBySegment": [
                                        {
                                            "segmentId": "1",
                                            "cabin": "BUSINESS",
                                            "fareBasis": "VH7OAVFN",
                                            "brandedFare": "FR",
                                            "class": "D",
                                            "includedCheckedBags": {
                                                "quantity": 2
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                        let currencycode = '$'
    
                        //rscode n19 start
                        if(r.data){
                           
                           
                            if (r.data.flightOffers && r.data.flightOffers.length>0 && r.data.flightOffers[0].price ){
                                price_tp = r.data.flightOffers[0].price
                                offer_tp = r.data.flightOffers[0]
                                currencycode = price_tp.currency == "USD" ? "$": price_tp.currency
        
                            }else{
                                console.log('sv**weeorr Nov19review LOADREVIEW ERROR')
                            }
                            let priceOb= {
        
                                "total": price_tp.grandTotal,
                                "base": price_tp.base,
                                "depositValue":"0",
                                "depositName":"Damage Deposit (Fully refundable)",
                                "currency": price_tp.currency || "USD",
                                "taxes": [
                                    {
                                        "amount": "5.00",
                                        "code": "ZP"
                                    },
                                    {
                                        "amount": "5.60",
                                        "code": "AY"
                                    },
                                    {
                                        "amount": "53.90",
                                        "code": "US"
                                    },
                                    {
                                        "amount": "4.50",
                                        "code": "XF"
                                    }
                                ],
                                "tax": {
                                   
                                    "taxTotal": currencycode+"00",
                                    "maintax":   currencycode+"00",
                                    "citytax":   currencycode+"00",
                        
                                    "taxPercent": "0",
                                    "citytaxPercent": "0"
                                },
                                "fees": [
                                    {
                                        "amount": "0.00",
                                        "type": "SUPPLIER"
                                    },
                                    {
                                        "amount": "0.00",
                                        "type": "TICKETING"
                                    },
                                    {
                                        "amount": "0.00",
                                        "type": "FORM_OF_PAYMENT"
                                    }
                                ]
                            }
                            priceOb.fees = price_tp.fees
                            priceOb.taxes = price_tp.taxes
                            if(priceOb){
                                my_data_review_tp.price = priceOb
                            }
                            if(offer_tp){
                                my_data_review_tp.offer = offer_tp
                            }
                            let comData = {my_data_flyreview:my_data_review_tp, my_data_flyaddress:null, my_data_card:null}
                             
                            //r3 address starts
                            let custProfileClone = {
                                customerId: -11
                            }
                            if( r3 &&  r3.data    && _.isArray(r3.data ) ){
        
                                
        
                                let ob3,sod3
                                const ar3 = r3.data 
                                const a_rec3 = ar3[0] || {}
                                ob3 = a_rec3
                                let my_data_flyaddress = ob3
                            
                                comData.my_data_flyaddress = my_data_flyaddress
                                console.log(my_data_flyaddress)
                                sod3 =  _.clone(ob3)
                                console.log(sod3)
        
                                my_data_review_tp.email = sod3.email
                                my_data_review_tp.addressType =sod3.addressType	? sod3.addressType :'B'
                                my_data_review_tp.fname = sod3.fname
                                my_data_review_tp.lname = sod3.lname
                                my_data_review_tp.addressId = sod3.addressId
                                my_data_review_tp.phone = sod3.phone
                                my_data_review_tp.email = sod3.email
                                my_data_review_tp.login = sod3.login
                                my_data_review_tp.city = sod3.city
                                my_data_review_tp.country = sod3.country
                                my_data_review_tp.state = sod3.state
                                my_data_review_tp.address = (sod3.address ?  sod3.address :"No address in DB")
                                my_data_review_tp.zip = sod3.zipcode
                                my_data_review_tp.isdcode = sod3.isdcode
                                my_data_review_tp.dcountry = sod3.country
                                console.log('sod3.dateOfBirth', sod3.dateOfBirth)
                                /*svf3 start */
                                my_data_review_tp[ "dateOfBirth"]= "" + sod3.dateOfBirth
                                /*my_data_review_tp.dateOfBirth = (sod3.dateOfBirth ? sod3.dateOfBirth:"1982-01-16") */
                                 /*svf3 end */
                                my_data_review_tp.gender = (sod3.gender ? sod3.gender:"MALE")
                                console.log('****sv FEB3 CRITITIT((((((((((((((((((((**************** START')
                                console.log(sod3)
                                console.log(my_data_review_tp)
                                console.log('****sv FEB3**CRTI (((((((((((((((((************** END')
                                /*
                                "dateOfBirth":"1982-01-16",
                                "gender":"MALE",
                                */
                                //dob  and gender for ods
        
                                if(sod3.customerId > 0){
                                    custProfileClone.customerId = sod3.customerId
                                    
                                    
                                }
                                if(sod3.addressId > 0){
                                    custProfileClone.addressId = sod3.addressId
        
                                }
        
                               
        
        
                            }
        
        
                            
                            comData.custProfile = custProfileClone
                            console.log('%%%sv*** svreviewaction  Nov19review comdata with custProfile froms db start')
                            console.log(custProfile)
                            //svr3 address end
                            //svr5 start
                            let my_data_geo = null
                            console.log('svj25 my_data_geo*********')
                            console.log(r5.data )
                            if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                             my_data_geo = r5.data
                             comData.my_data_geo = my_data_geo
                            }
                            console.log(comData )
                            //svr5 end
                            //svr4 card start
                            if( r4.data  && r4.data.length>0){
        
                                
        
                                let ob4,sod4
                                const ar4 = r4.data 
                                const a_rec4 = ar4[0] || {}
                                ob4 = a_rec4
                                let my_data_card = ob4
                                if(my_data_card.cardId && my_data_card.cardId > 0){
                                    my_data_card.id =  my_data_card.cardId
                                }else{
                                    my_data_card.id = -12
                                }
                                if(my_data_card.cardNumber && my_data_card.cardNumber.length > 0){
                                    my_data_card.card =  my_data_card.cardNumber
                                }else{
                                    my_data_card.cardNumber = "7777777777777777"
                                }
                                if(my_data_card.cardCvv && my_data_card.cardCvv.length > 0){
                                    my_data_card.cvv =  my_data_card.cardCvv
                                }else{
                                    my_data_card.cvv = "777"
                                }
                            
                                if(my_data_card.cardExpMonth && my_data_card.cardExpMonth.length > 0){
                                    my_data_card.mmexp =  my_data_card.cardExpMonth
                                }else{
                                    my_data_card.mmexp = "07"
                                }
                            
                                if(my_data_card.cardExpYear && my_data_card.cardExpYear.length > 0){
                                    my_data_card.yyyyexp =  my_data_card.cardExpYear
                                }else{
                                    my_data_card.yyyyexp = "77"
                                }
                            
                            
                                comData.my_data_card = my_data_card
                            }
                            console.log('**SV Nov19review for exisitng customer Oct8*******')
                            console.log(comData)
                            console.log('%%%sv*** svreviewaction comdata with custProfile froms db end')
                   
        
                            //svr4 card end
                            dispatch(getFlyLoadReviewNyReservationCustSuccess(comData))
                        }else{
                            //abadon booking or review
                            let  my_data_geo= {
                                "countryTypes": [
                                    {
                                        "name": "United STates America",
                                        "a2": "US",
                                        "a3": "USA",
                                        "value": "USA",
                                        "isonum": "840"
                                    },
                                    {
                                        "name": "Canada",
                                        "isdcode": "01",
                                        "a2": "CA",
                                        "a3": "CAN",
                                        "value": "CAN",
                                        "isonum": "124"
                                    }
                                ],
                                "stateTypes": [
                                    {
                                        "name": "California",
                                        "value": "CA",
                                        "a2": "CA"
                                    },
                                    {
                                        "name": "New York",
                                        "value": "NY",
                                        "a2": "NY"
                                    },
                                    {
                                        "name": "Texas",
                                        "value": "TX",
                                        "a2": "TX"
                                    }
                                ],
                                "isdcodeTypes": [
                                    {
                                        "name": "United States Of America(+1)",
                                        "value": "1"
                                    },
                                    {
                                        "name": "Australia(+61)",
                                        "value": "61"
                                    },
                                    {
                                        "name": "Spain(+34)",
                                        "value": "34"
                                    }
                                ],
                                "genderTypes": [
                                    {
                                        "name": "CL_MALE",
                                        "value": "MALE"
                                    },
                                    {
                                        "name": "CL_FEMALE",
                                        "value": "FEMALE"
                                    }
                                ]
                            }
                            const comData = {my_data_flyreview:my_data_review_tp, my_data_geo:my_data_geo}
                            comData.custProfile =null
                            dispatch(getFlyLoadReviewNyReservationCustSuccess(comData))
                  
        
                        }
        
                        
                        //rscode n19 end
                    })
                ).catch(
                    e=>dispatch(getLoadReviewError(e))
                )
                /*svdec4 end*/


        }
        ).catch(
            
            e=>dispatch(getLoadReviewError(e))
        )



        //localhost:8086/account/cardListByCustomerIdView
      
        
    }
}
    

/*svf4 end*/

/*vf5 start*/
export const getFlyMailUserSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_FLYREVIEW_MAILUSER_SV_SUCCESS',
        payload: data
    })
}


export function mailIuser(obp){
    console.log('%%%%%%%%%%%%%%%sv++++REST API mailIuser obo :' + obp)
   
    let nameQParam = obp.um
    let custProfile = obp.custProfile
    const {customerId}  = custProfile
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svFlyLoadReviewBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       //http://localhost:8082/amcos/amcosmosbika/kksvverificationCodekk
        const urlDelete = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svverificationCode`
        const bodyDelete = {
            "email": nameQParam? nameQParam : "suelb22@yahoo.com",
            "subject": "Reservation Details",
            "customerId": customerId ? (""+ customerId):  "-131",
            "status": "OK",
            "digitalCode": "111111"
        }
        

       
        
         
        axios.post(urlDelete, bodyDelete, {headers:headers})
        .then(
            r => {
                //fix n4y25 we get object
                let  tok_ob = null
               let payload = r.data
               if( _.isObject(payload)){
                 tok_ob = payload
                const comData = { my_data_dtoken:  tok_ob }

               console.log('sv nov4y25*****YES****got the token  calling to mailUser the token')
                dispatch(getFlyMailUserSuccess(comData))

               } else if (_.isArray(payload)){
               // if( _.isObject(payload)){
                     tok_ob = payload[0]
                    const comData = { my_data_dtoken:  tok_ob }

                   console.log('sv nov4y25*****YES****got the token  calling to mailUser the token')
                    dispatch(getFlyMailUserSuccess(comData))
                }
                else {
                    console.log('sv nov4y25****ERROR***TtokenERROR  calling to REVIEWERROR the token')
                    let hwrs =  {
                        "email": "suelb22@yahoo.com",
                        "subject": "Reservation Details",
                        "customerId": "-131",
                        "status": "OK",
                        "digitalCode": "111111"
                    }
                    const comData = { my_data_dtoken: hwrs}
                    dispatch(getLoadReviewError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
        
    }

}
/*
export function mailIuser(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svFlyLoadReviewBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       //http://localhost:8082/amcos/amcosmosbika/kksvverificationCodekk
        const urlDelete = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svverificationCode`
        const bodyDelete = {
            "email": "suelb22@yahoo.com",
            "subject": "Reservation Details",
            "customerId": "-131",
            "status": "OK",
            "digitalCode": "111111"
        }
        

       
        
         
        axios.post(urlDelete, bodyDelete, {headers:headers})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    const comData = { my_data_dtoken:  ar }

                   
                    dispatch(getFlyMailUserSuccess(comData))
                }
                else {
                    let hwrs =  {
                        "email": "suelb22@yahoo.com",
                        "subject": "Reservation Details",
                        "customerId": "-131",
                        "status": "OK",
                        "digitalCode": "111111"
                    }
                    const comData = { my_data_dtoken: hwrs}
                    dispatch(getLoadReviewError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
        
    }

}
*/
/*svf5 end*/